import { useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { CardText } from 'react-bootstrap-icons';
import SearchIcon from "../assets/images/search-lg-icon.svg";
import filterLines from "../assets/images/filter-lines.svg";
import cardtext from "../assets/images/card-text.svg";
import questionicon from "../assets/images/question-circle-fill.svg";
import downloadIcon from "../assets/images/download-icon.svg";
import trashIcon from "../assets/images/trash-icon.svg";
import personalityreporticon from '../assets/images/personality-report.png'
import threeDots from "../assets/images/dots-vertical.svg";
import mediator from "../assets/images/mediator.svg";
import mediatorLetter from "../assets/images/m-mediator.svg";
import shareicon from "../assets/images/share.svg";
import influencer from "../assets/images/influencer.svg";
import Pioneer from "../assets/images/pioneer.svg";
import summaryIco from '../assets/images/candidate summary.png'
import detailedPersonalityIcon from '../assets/images/detailed personality.png'
import logicalthinker from "../assets/images/logical-thinker.svg";
import teamplayer from "../assets/images/team-player.svg";
import persuader from "../assets/images/persuader.svg";
import achiever from "../assets/images/achiever.svg";
import perfectionist from "../assets/images/perfectionist.svg";
import collaborator from "../assets/images/collaborator.svg";
import assessor from "../assets/images/accessor.svg";
import implementor from "../assets/images/implementor.svg";
import motivator from "../assets/images/motivator.svg";
import leader from "../assets/images/leader.svg";
import administrator from "../assets/images/administrator.svg";
import versatile from "../assets/images/versatile.svg";
import mail1 from "../assets/images/email.png";
import del1 from "../assets/images/bin.png";
import file2 from "../assets/images/excel.png";
import exp1 from "../assets/images/export.png";
import refresh from "../assets/images/refresh.svg"
import versatileletter from "../assets/images/versatileletter.svg";
import influencerletter from "../assets/images/i-influencer.svg";
import MultipleSelectCheckmarks from "../component/selectwithCheckbox";
import pioneerletter from "../assets/images/p-pioneer.svg";
import logicalthinkerletter from "../assets/images/l-logical.svg";
import teamplayerletter from "../assets/images/t-teamplayer.svg";
import persuaderletter from "../assets/images/p-persuader.svg";
import achieverletter from "../assets/images/a-achiever.svg";
import perfectionistletter from "../assets/images/p-perfectionist.svg";
import collaboratorletter from "../assets/images/c-collaborator.svg";
import assessorletter from "../assets/images/a-accessor.svg";
import implementorletter from "../assets/images/i-implementor.svg";
import motivatorletter from "../assets/images/m-motivator.svg";
import leaderletter from "../assets/images/l-leader.svg";
import administratorletter from "../assets/images/a-aadministrator.svg";
import mediatorletter from "../assets/images/m-mediator.svg";
import downloadicon from "../assets/images/download-icon.svg";
import one from "../assets/images/one-circle.svg";
import two from "../assets/images/two-circle.svg";
import check from "../assets/images/check.svg";
import mail from "../assets/images/mail.svg";
import crosscircle from "../assets/images/cross.svg";
import whatsappss from "../assets/images/whatsapp.png";
import downl from "../assets/images/download.svg";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import inProg from "../assets/images/in-progress-svgrepo-com (2).svg";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

import {
  PostCallWithErrorResponse,
  postWithAuthCallWithErrorResponse,
  simpleDeleteCall,
  simpleGetCall,
  simpleGetCallTime,
  simpleGetCallWithErrorResponse,
} from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import NoDataFound from "../component/noDataFound";
import FileSaver from "file-saver";
import Moment from "react-moment";
import searchicon from "../assets/images/search-lg-icon.svg";
import { Button, Select, Space, Table, Tag, Tooltip } from "antd";
import _, { set } from "lodash";
import { render } from "@testing-library/react";
import { json, Link } from "react-router-dom";
import { Badge, Form, FormControl, Modal } from "react-bootstrap";
import axios from "axios";
import { AppContext } from "../context/AppContext";
import { useQuill } from "react-quilljs";
import { toastMsg } from "../component/toast";
import { toast } from "react-toastify";
import { mailTypes } from "../constant/mailType";
import UserActivity from "./userActivity";
import AdvanceFilter from "./advanceFilte";
import CustomSelect from "../constant/customselect";
import filterApplicant from "../constant/advanceFilter";
import AddNotes from "./addNotes";
import DetailedPersonality from "./detailedPersonality";
import PersonalityReoprtALert from "./PersonalityReportALert";
import MessageBox from "../component/MessageBox";
import CustomButton from "../component/button";



const AccessCode = (props) => {
  const { quill, quillRef } = useQuill();
  const [rowsToShow, setRowsToShow] = useState(10);

  const { code } = useParams()

  const [showSummaryMsg, setSummaryMsg] = useState(false)

  const { respondendByCode } = props;

  const [selectedList, setSlectedList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [filteredData, setFilteredData] = useState([]);

  const [notes, setNotes] = useState([])

  const [permissions, setPermission] = useState({})

  const [position, setPosition] = useState("")

  const [isShowCandidateReport, setIsShowCandidateReport] = useState(false)


  const [downloadBtn, setDownloadBtn] = useState(false);
  const [isAddNotes, setIsAddNotes] = useState(false)

  const [isDetailedPersonality, setIsDetailedPersonality] = useState(false)

  const [quizSource, setQuizSource] = useState('')

  const [isActive, setIsActive] = useState(true);

  const [counyMatch, setCountMatch] = useState(0)

  const [isDefaultEmailContent, setIsDefaultEmailContent] = useState(false)

  const [userId, setUserId] = useState(0)
  const [showLog, setShowLog] = useState(false)
  const [userName, setUserName] = useState('')

  const navigate = useNavigate()


  const [search, setSearch] = useState("");

  const [isFilter, setIsFilter] = useState(false)

  const [status, setStatus] = useState('')

  const [type, setType] = useState("");

  const [isShortAssement, setIsShortAssessment] = useState(false)

  const [selectedTags, setSelectedTags] = useState({

  })

  const [filterList, setFilterList] = useState([])
  const [selectedFilter, setSelectedFilter] = useState('')
  // const [code, setCode] = useState("");

  const [customQuestion, setCustomQuestion] = useState([]);

  const { adminData, companyDtls } = useContext(AppContext);

  const [emailContentType, setEmailContentType] = useState(0)

  const [credits, setCredits] = useState({})

  const [isDiasableSearch, setIsDisableSearch] = useState(false);

  const [codeId, setCodeId] = useState("");
  const handleRowsToShowChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  const [allData, setAllData] = useState([]);
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
  const [isClearFilters, setIsClearFiltres] = useState(false)

  const [mailKey, setMailKey] = useState(0)

  const [accessCodeList, setAccessCoeList] = useState([]);

  const [statusOptionss, setStatusOptions] = useState([])
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];


  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };
  const modules = {
    toolbar: [
      // [{ size: [] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link", "image"],
      // [{ color: [] }, { background: [] }],
      // ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
    // imageResize: {
    //   parchment: Quill.import("parchment"),
    //   modules: ["Resize", "DisplaySize"],
    // },
  };
  const placeholder = "type here...";

  useEffect(() => {
    getTags()
  }, [])

  useEffect(() => {
    console.log(companyDtls);

    if (code?.length > 0 && adminData?.email) {
      getList(code);

      setIsDisableSearch(true);

      // setCode(respondendByCode);

    }
  }, [adminData?.email]);

  useEffect(() => {
    if (search.length || isFilter) return;

    if (accessCodeList?.length < allData?.length) {
      setAccessCoeList((prev) => [
        ...prev,
        ...allData?.slice(accessCodeList?.length, accessCodeList?.length + 50),
      ]);
    }
  }, [accessCodeList]);


  const getTags = useCallback(() => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_TAGS_BY_CODE + code).then((res) => {

      if (res?.json?.succeded) {
        setStatusOptions(res?.json?.response)
      }

    })
  }, [])


  const getList = useCallback((code, isActive = true) => {
    //'AFB6CF'
    setSelects([])
    setIsLoading(true);
    const param1 = code?.toUpperCase();
    const param2 = false;

    const url = `${ApiConfig.ACCESS_CODE_LIST}code=${param1}&export=${param2}&isActive=${isActive}&email=${adminData?.email}`;
    postWithAuthCallWithErrorResponse(url, JSON.stringify({}))
      .then((res) => {
        // setIsLoading(true)

        if (res?.json?.succeded) {
          setAllData(res?.json?.response);
          setCodeId(res?.json?.response[0]?.id);
          console.log(res?.json?.response[0]?.id, "ideses");
          setIsShortAssessment(!res?.json?.isShortAssessment)
          setCustomQuestion(res?.json?.questions);
          setQuizSource(res?.json?.quizSource)

          setAccessCoeList(res?.json?.response?.slice(0, 25));

          setPermission(res?.json?.permission)

          setType(
            res?.json?.reason
          );

          setCredits(res?.json?.aiCredits)
          setPosition(res?.json?.position)
          console.log(res.json.response.length);
        } else {
          setAccessCoeList([]);
          setAllData([]);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  const deleteBulkUser = () => {

    if (selects?.length === 0) return

    let payload = {
      userIds: selects
    }
    PostCallWithErrorResponse(ApiConfig.DELETE_USER_IN_BULK, payload).then((res) => {

      if (res?.json?.succeded) {

        toastMsg('success', res?.json?.response?.statusMessage || 'Users deleted Successfully !')
        getList(code, isActive)
        setSelects([])
        setSelectsRec([])

      } else {
        toastMsg('error', res?.json?.response?.statusMessage)
      }

    })

  }

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const ResponseApi = (id) => {
    let emails;

    if (selectsRec?.length > 0) {

      emails = selectsRec?.map((i) => i?.emailId);
    } else {
      emails = filteredData?.length
        ? filteredData?.map((i) => i?.emailId)
        : accessCodeList?.map((i) => i?.emailId);
    }

    postWithAuthCallWithErrorResponse(
      ApiConfig.DOWNLOAD_USER_RESPONSES + id,
      JSON.stringify({ emailId: emails })
    ).then((res) => {
      let data = res?.json;

      if (data?.status) {
        FileSaver.saveAs(
          "data:" + data?.contentType + ";base64," + data?.data,
          data?.fileName
        );
      }
    });
  };

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const [sel, setSel] = useState(null);

  const [mailRecords, setMailRecords] = useState({
    all: 0,
    notInrsted: 0,
    sendTo: []
  })

  const handleChange = (pagination, filters, sorter, currentDataSource) => {
    setSelects([]);

    setSelectsRec([]);

    setFilteredData(currentDataSource?.currentDataSource);
    // setAccessCoeList(currentDataSource?.currentDataSource)
    setSel(currentDataSource?.currentDataSource.length);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const downloadExcelfile = async (userid) => {
    try {
      console.log("Starting file download for user:", userid);
      const response = await fetch(
        `https://api-beta.lywo.in/api/Assessment/GenerateExcel/generateExcel?UserId=${userid}`,
        {
          method: "GET",
          mode: "cors",
        }
      );
      console.log("Response:", response);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      console.log("Blob created:", blob);
      toastMsg("success", "File downloaded successfully.");
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "PersonalityData.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
      console.log("File downloaded successfully.");
    } catch (error) {
      console.error("There was an error downloading the Excel file!", error);
    }
  };

  const downloadExcel = async (userId) => {
    try {
      const curl = `https://api-beta.lywo.in/api/Assessment/GenerateExcel/generateExcel?UserId=${userId}`;
      const response = postWithAuthCallWithErrorResponse(
        url,
        JSON.stringify({})
      );

      // const response = await fetch(`https://api-beta.lywo.in/api/Assessment/GenerateExcel/generateExcel?UserId=${userId}`, {
      //     method: 'GET',
      //     headers: {
      //         'Content-Type': 'application/json'
      //     },
      //     credentials: 'include', // Include cookies (if needed), or use 'same-origin' depending on your needs
      // });

      // if (!response.ok) {
      //     throw new Error('Network response was not ok');
      // }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "PersonalityData.xlsx"); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Cleanup
    } catch (error) {
      console.error("There was an error downloading the Excel file!", error);
    }
  };

  const updateStatus = (status) => {



    if (selects.length === 0) {
      toastMsg('error', 'Please Select Applicants !')
      setStatus('')
      return
    }

    let payload = {
      "userIds": selects,
      "status": status,
      "jobcode": code,
      adminEmail: adminData?.email
    }

    PostCallWithErrorResponse(ApiConfig.UPDATE_CANDIDATE_STATUS, payload).then((res) => {

      if (res?.json?.succeded) {
        setSelects([])

        setSelectsRec([])
        toastMsg('success', res?.json?.response?.statusMessage)
        getList(code, isActive)
      }

      setStatus('')

    })

  }

  const savePersonalityReport = (report) => {

    const payload = {
      "userId": userId,
      "code": code,
      "personalityReport": "",
      Admin: adminData?.email
    }

    PostCallWithErrorResponse(ApiConfig.SAVE_PERSONALITY_REPORT, payload)

  }


  const deleteRecord = (userId, value) => {
    const url = `${ApiConfig.DELETE_USER_AND_DEP}userid=${userId}`;
    simpleDeleteCall(url, userId)
      .then((res) => {
        if (res?.response?.status == true) {
          console.log("User record deleted successfully.");
          toastMsg("success", "User record deleted successfully.");
          getList(value?.code);
        } else {
          console.log("Unexpected response");
        }
      })
      .catch((error) => {
        console.error("Error deleting user record:", error);
      });
  };
  // const removeUserIdFromList = (userId) => {
  //   setAllData((prevUsers) => prevUsers.filter((user) => user.id !== userId));
  //   setAccessCoeList((prevUsers) =>
  //     prevUsers.filter((user) => user.id !== userId)
  //   );
  // };

  //   const downloadExcel = async (userId) => {
  //     try {
  //         const response = await axios.get(`https://api-beta.lywo.in/api/Assessment/GenerateExcel/generateExcel`, {
  //             params: { UserId: userId },
  //             responseType: 'blob' // Important to handle the binary data
  //         });
  //     console.log(response);
  //         const url = window.URL.createObjectURL(new Blob([response.data]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', 'PersonalityData.xlsx'); // Set the file name
  //         document.body.appendChild(link);
  //         link.click();
  //     } catch (error) {
  //         console.error("There was an error downloading the Excel file!", error);
  //     }
  // };

  function formatDate(date) {
    if (!date) return "";
    const [year, month, day] = date.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
  }
  const [perList, setPerList] = useState([
    {
      id: 1,
      img_card: influencer,
      img_letter: influencerletter,
      personality: "Influencer",
      text: "Influencers are confident, outgoing and friendly individuals who love to be the center of attention. They seek out situations that involve meeting people and socializing. Their confidence combined with a genuine interest in ideas and people, allows them to interact easily, and positively in almost any situation. These strong communicators are assertive, intuitive, and adaptive. They thrive in meetings, committees, and conferences. They may need a constant dose of Approval. They also might sometimes lose focus on timelines and the tasks at hand.",
      strengths:
        "Fun, persuasive, ideas-oriented, creative, original, networkers, intuitive",
      uniqueness: "Openness, strong communication, social confidence",
      valtoorg:
        "Contributing original ideas, improve and extend coordination within team",
      challenges: "Needs constant approval, pressured conditions",
      motivations:
        "Being surrounded by people, supportive and collaborative environment",
    },
    {
      id: 2,
      img_card: Pioneer,
      img_letter: pioneerletter,
      personality: "Pioneer",
      text: "Pioneers are often ambitious, competitive, and strong-willed individuals. They have a very high need to achieve and continually seek new horizons. Their self-reliance and independent thinking drive them to escape convention and create innovative solutions. They are direct and assertive and apt at influencing people. They are dynamic, adaptable, and willing to do anything to overcome obstacles. Pioneers are persistent in their pursuit of desired results. Overcome by their desire to achieve their goals, they might fail to take other people’s feelings into consideration. Additionally, they have high expectations of others and can be critical if their standards are not met.",
      strengths:
        "Action-oriented, resourceful, self-reliant, decisive, proactive, strong-willed, direct",
      uniqueness:
        "Sound decision making, self-motivated, excels in emergencies",
      valtoorg: "Innovative solutions; taking responsibility",
      challenges: "Too independent, tends to be blunt, boredom",
      motivations:
        "New opportunities, strong need to achieve, power and structure.",
    },
    {
      id: 3,
      img_card: logicalthinker,
      img_letter: logicalthinkerletter,
      personality: "Logical Thinker",
      text: "Logical thinkers are hardworking, logical, and detail-oriented individuals with high critical thinking abilities. Their habit of meticulous preparation, accuracy, and correctness helps them to manage tasks effectively. Despite being shy and mild-mannered, logical thinkers have a strong need to control their environment. They exert rules, structure, and standards, to accomplish their goals, in conflicting situations. Their cautiousness makes them reluctant to reveal information about themselves or their thoughts unless necessary. Being natural risk avoiders, they only undertake tasks when they are completely certain about the outcome.",
      strengths:
        "Quality control, handling detail, analyzing data, logical, avoiding the risk, building structure, being deliberate and methodical",
      uniqueness: "Accuracy; ability to think logically; building structure",
      valtoorg:
        "Completes the undertaken task; great at quality control; organizing information",
      challenges:
        "Spotting deficiencies first; controlling; lacks assertiveness",
      motivations:
        "Certainty of situation and consequences; getting things right",
    },
    {
      id: 4,
      img_card: teamplayer,
      img_letter: teamplayerletter,
      personality: "Team Player",
      text: "Team players are friendly, calm, and thoughtful individuals that like doing practical jobs. Amidst their calm nature, controlled stance, modest attitude, and excellent listening skills, they tend to empathize with others’ perspectives. They value positive interactions and are always willing to help. They depend on more socially assertive people to take the lead. Their persistence and patience enable them to work steadily until the task is completed. They value trust strongly and enjoy being part of a smaller team where they are valued and appreciated. Typically, they resist change and need help in developing alternative solutions.",
      strengths:
        "Flexibility, dependability, harmony, warmth, listening, team-focused, loyal",
      uniqueness: "Listens effectively, supportive, works steadily",
      valtoorg:
        "Capable of dealing with laborious tasks; works on a task until it is achieved",
      challenges: "Sudden change; interruptions and distractions",
      motivations:
        "Helping others succeed; support of people; doing practical jobs",
    },
    {
      img_card: persuader,
      img_letter: persuaderletter,
      personality: "Persuader",
      text: "Persuaders are assertive, adventurous, and confident individuals with strong social skills. They can be charming or demanding, based on the circumstances. They tend to approach people and situations with energy. While communicating, they can be both assertive and persuasive. Their ability to think and react quickly lets them easily adapt to challenging situations. They have no fear of confrontation and address issues directly. They have clear goals in life and achieve them with sheer determination and commitment. Persuaders thrive in situations that others would find impossibly stressful and difficult. They live for and are happiest when on adventures.",
      strengths:
        "Charming, visionary, adventurous, bold, high energy, results-focused, exciting and fun",
      uniqueness:
        "Sound decision making, self-motivated, excels in emergencies",
      valtoorg:
        "Thrives under pressure; motivates people; commits and achieves results",
      challenges: "Stagnation; can get aggressive under pressure",
      motivations: "Success and recognition; new experiences and challenges",
    },
    {
      img_card: achiever,
      img_letter: achieverletter,
      personality: "Achiever",
      text: "This is an extremely rare profile with radically different sets of values and motivations. Achievers are reliable, persistent, tenacious, and industrious individuals with a strong sense of personal accountability. They like to get things done in a friendly but thorough manner. They are focused on results with a strong inclination towards fair play and respect. Their careful planning allows them to complete tasks within realistic timescales. They tend to be thoughtful in favorable conditions and demanding at times of pressure. Achievers are usually cautious and only open up to a small set of people they completely trust. They function at peak efficiency and expect recognition equal to their contribution.",
      strengths:
        "Patient, tenacious, dependable, consistent, protective, kind, watchful",
      uniqueness: "Methodical in approach; accountability of work",
      valtoorg: "Self-driven and completes tasks effectively",
      challenges: "Poor communication; inferior work",
      motivations: "Personal and professional accomplishments",
    },
    {
      img_card: perfectionist,
      img_letter: perfectionistletter,
      personality: "Perfectionist",
      text: "Perfectionists are tenacious, competitive, systematic, and creative individuals with opposing behavioral forces. They seek immediate results and have an equally strong desire for perfection. Their ability to plan and achieve quality allows them to make sound decisions. They think and act quickly but also evaluate all options before agreeing to a course of action. In their drive for results and perfection, they demand the freedom to explore and the authority to examine. They are straightforward and enjoy working by themselves. They tend to be careful with relationships and prefer a strategic approach when dealing with others. They are open to change but extremely cautious.",
      strengths:
        "Tenacity, quality control, handling large amounts of detail, analyzing data, building systems, competing to win, results-focused, striving to be the best",
      uniqueness:
        "Attention to detail; tries innovative approaches using existing systems",
      valtoorg:
        "Can bring positive change to the team by challenging them and raising the standards",
      challenges: "Bored with routine work; gets lost in detail",
      motivations: "Unique accomplishments and dominance",
    },
    {
      img_card: collaborator,
      img_letter: collaboratorletter,
      personality: "Collaborator ",
      text: "Collaborators are warm, empathetic, easygoing and relaxed individuals that socialize with ease. They tend to think of others first over themselves. They strive to maintain harmony and build long-term relationships. Being good listeners, they make others feel heard and offer suggestions gently. They are sympathetic in nature and fulfil supportive roles well. They often provide recognition to others and attribute less importance to task accomplishment. They love to work in team settings and appreciate environments that ensure stability with minimal change. While they generally avoid conflict and confrontation, they are willing to mediate with others to restore harmony.",
      strengths:
        "Versatile, warm, responsive, upbeat, respectful, loyal, enthusiastic",
      uniqueness: "Group acceptance and approval; friendliness",
      valtoorg:
        "Effective listening skills; bring stability and harmony to the team",
      challenges:
        "Conflicting situations; over-commitment; boredom; cannot confront or give direct orders.",
      motivations:
        "Recognition from people around; peaceful environment where they can collaborate with others",
    },
    {
      img_card: assessor,
      img_letter: assessorletter,
      personality: "Assessor",
      text: "Assessors are articulate, creative, organized, and well-researched individuals with a unique blend of contradicting traits. They seek the company of others but are also exhausted by them. On one hand, they are outgoing and impulsive in favorable conditions yet in formal situations, they are precise and rule-abiding. They are naturally skilled at influencing people with strong communication. They are imaginative, perceptive and strive for perfection. They elicit cooperation from others by being considerate. They have the desire to win and can overwork to the point of exhaustion. They are practical and ensure progressive results by developing a detailed plan of action.",
      strengths:
        "Articulate, well-researched, produce quality results, self-disciplined, careful, expressive, enthusiastic, fun",
      uniqueness:
        "Turning dreams into workable concepts; result-oriented and quality-driven",
      valtoorg:
        "Brings new ideas to the table; team players that instigate action and activities",
      challenges: "Not knowing when to stop; sensitive to criticism",
      motivations: "Winning attention and approval; succeeding at all costs",
    },
    {
      img_card: implementor,
      img_letter: implementorletter,
      personality: "Implementor ",
      text: "Implementors are stable, consistent, pragmatic, and accommodating individuals that are driven by patience, accuracy, and logic. They are precise thinkers and through precautions avoid the unexpected. They prefer traditional approaches. They question assumptions and require loads of information that they can analyze when exploring alternatives and before reaching conclusion. They enjoy overcoming challenges through persistence and intense focus. They are calm and rational folks, and they rarely provide input in a group. They hold themselves to high standards and desire to earn the respect of those around them.",
      strengths:
        "Dependable, stable, careful, accurate, hard working, patient, diplomatic",
      uniqueness: "Brings stability on board; sticks to “fail safe” options",
      valtoorg:
        "Works diligently to get the job done; maintains quality and standards",
      challenges: "Reluctant to change; takes time to adapt",
      motivations: "Predictable and stable outcomes; recognition for work",
    },
    {
      img_card: motivator,
      img_letter: motivatorletter,
      personality: "Motivator",
      text: "Motivators are dependable, social, assertive, and determined individuals that have a clear idea of their life goals and the will power to achieve them.They have a strong sense of independence.Their unique combination of patience and proactivity makes them effective facilitators and motivators.They thrive on working with people, challenging tasks, and spontaneity.They are warm, well- liked, competitive and result oriented.They get results and consider options before execution but do not get bogged down by too much detail or accuracy.They maintain good relations and motivate people around them.Their positive outlook might make them too optimistic, and they overestimate their ability to change the behaviour of others",
      strengths:
        "Dependable, socially skilled, patient, warm, interesting and fun, driven to achieve, self-reliant",
      uniqueness:
        "Clarity on goals and ways to accomplish; control over circumstances",
      valtoorg:
        "Confidently suggests innovative ideas; assigns tasks effectively",
      challenges:
        "Being asked to investigate too much detail; routine and regimen",
      motivations: "New opportunities; strong need to achieve",
    },
    {
      img_card: leader,
      img_letter: leaderletter,
      personality: "Leader",
      text: "Leaders are practical, innovative, self-reliant, and ambitious individuals that are always pushing to make things better. They are friendly, charming, and enthusiastic in casual circumstances but tend to be direct, forthright, and assertive in formal setups. They like taking responsibility and taking credit for both wins and losses, as long as they have control of the results. They do not shy away from taking command when needed and may be impatient with the inefficiencies of others. They are sensitive to the needs of the team. They find a balance between personal ambitions and group goals. They are very clear thinkers, make good decisions and promote harmony in the team.",
      strengths:
        "Driven, innovative, practical, self-reliant, leadership ability, confident, clear thinking",
      uniqueness: "Accommodating and inspiring; drive to make things better",
      valtoorg: "Persistently accomplishes goals with inclusivity of team",
      challenges:
        "Impatience when things don’t go a certain way; being managed",
      motivations:
        "Opportunity to get things done in their way; supporting the team",
    },
    {
      img_card: administrator,
      img_letter: administratorletter,
      personality: "Administrator ",
      text: "Administrators are steady, objective, clear-minded and analytical individuals that get results and keep the team happy at the same time. They have a clear view of their aims in life. Their patience and thoughtfulness help them avoid risks. They guard their thoughts and reveal them only after careful thought and consideration. They choose their words carefully, make practical decisions, and rely upon logic rather than emotion. They possess the drive to track detail and the desire to build the harmony needed to run the team. While being good executors, they rarely bring in the imagination and vision needed for innovative initiatives. They can be both dominant and supportive based on the situation.",
      strengths:
        "Productive, efficient, practical, pragmatic, thoughtful, detail-oriented, patient",
      uniqueness: "Uses logic effectively to get results",
      valtoorg:
        "Works with determination; can work individually or with others",
      challenges: "Tendency to get overworked; being blunt; not creative",
      motivations:
        "Achieving results by taking time to adapt to changing situations; attention to detail; avoiding risk",
    },
    {
      img_card: mediator,
      img_letter: mediatorLetter,
      personality: "Mediator ",
      text: "Mediators are creative, well-spoken, and understanding individuals that enjoy being a team member and helping others succeed. They love being in a supportive role and can bring valuable insights if given the time needed to think. They are rational in problem-solving and adept at presenting arguments in a credible manner. Their insistence on taking things at their own pace might not be agreeable to all. They prefer a cooperative environment where people are trustworthy and pleasant. They thrive on their contribution to projects that require attention to detail. They have high expectations of themselves and others around them and might voice disapproval when their expectations are not met.",
      strengths:
        "Productive, well-spoken, researching, harmonious, collaborative, co-operative, detail-oriented, patient",
      uniqueness: "Accommodating and inspiring",
      valtoorg: "Skilled and proficient in problem solving; highly skilled",
      challenges:
        "Aversion to risks and being too predictable; not recognized as experts.",
      motivations:
        "Supporting and interacting with others; learning from and teaching to others.",
    },
    {
      img_card: versatile,
      img_letter: achieverletter,
      personality: "All Rounder",
      text: "The All Rounders are individuals who exhibit a balanced mix of behaviours and traits which results in no specific aspect of their behaviour that stands out. This unique blend allows them to adapt to a wide range of situations and environments effectively. They may often encounter challenges with leadership roles that require consistency and direction. They might find it challenging to thrive in roles demanding strong personality traits or high performance and action, they excel in environments where a balanced approach is advantageous. Their flexibility enables alignment with diverse groups making them a valuable team player. Overall, they enrich any organization with their unique ability to perceive multiple perspectives.",
      strengths:
        "Fit into different contexts based on situational needs; Versatility in handling multiple tasks, Flexible",
      uniqueness:
        "Adaptability akin to a chameleon; Adept at multiple perspective-taking.",
      valtoorg:
        "Ideal for diverse departments; Bridge gaps between different personality types, Fosters collaboration.",
      challenges:
        "Overwhelmed in highly demanding or unfamiliar situations; Lack of specialization; Leadership roles; Lacks consistency.",
      motivations:
        "Stability in work environment; Easing into tasks; Opportunities to utilize adaptability and versatility.",
    },
  ]);
  const [onePer, setOnePer] = useState([]);
  const [showmodal, setShowmodal] = useState(false);
  // const [completedPercentages, setCompletedPercentages] = useState(0);
  const handleShow = (rec, per) => {
    if (rec === "N/A" || rec === null) {
      setOnePer([]);
      return;
    }
    setShowmodal(true);
    setOnePer(perList.filter((x) => x.personality.trim() === rec.trim()));
  };
  const handleCloseModal = () => setShowmodal(false);

  // const [showPerCard, setShowPerCard] = useState(false);
  // const handleShowPersonalityCard=()=>{
  //   setShowPerCard(true);
  //   setShowmodal(false);
  // }
  // const handleClosePerCard=()=> setShowPerCard(false);

  // const [showMainPerCard, setShowMainPerCard] = useState(false);
  // const handleShowMainPercard = ()=> {
  //   setShowMainPerCard(true);
  //   setShowPerCard(false);
  // }
  // const handleCloseMainpercard=()=> setShowMainPerCard(false);

  // const handleCloseAllPops=()=>{
  //   setShowmodal(false);
  //   setShowPerCard(false);
  //   setShowMainPerCard(false);
  // }

  const [selectAll, setSelectAll] = useState(false);

  // const handleSelectAll = (checked) => {
  //   if (checked) {
  //     const currentDisplayData = filteredData.length > 0 ? filteredData : accessCodeList;
  //     const allUserIds = currentDisplayData.map(record => record.userId);

  //     // const allUserIds = accessCodeList.map(record => record.userId);
  //     setSelects(allUserIds);
  //     setSelectsRec(accessCodeList);
  //     // console.log(allUserIds);
  //     // console.log(accessCodeList);
  //   } else {
  //     setSelects([]);
  //     setSelectsRec([]);

  //   }
  //   setSelectAll(checked);
  // };
  // const handleSelectAll = (checked) => {
  //   if (checked) {
  //     // Get the current filtered data from the table
  //     const currentFilteredData = accessCodeList.filter(record => {
  //       // Apply all current filters
  //       for (let key in filteredInfo) {
  //         if (filteredInfo[key] && columns.find(col => col.dataIndex === key)?.onFilter) {
  //           const filterFn = columns.find(col => col.dataIndex === key).onFilter;
  //           if (!filterFn(filteredInfo[key], record)) {
  //             return false;
  //           }
  //         }
  //       }
  //       return true;
  //     });

  //     // Set selections based on filtered data
  //     setSelects(currentFilteredData.map(record => record.userId));
  //     setSelectsRec(currentFilteredData);
  //   } else {
  //     setSelects([]);
  //     setSelectsRec([]);
  //   }
  //   setSelectAll(checked);
  // };

  // const handleSelectAll = (checked) => {
  //   if (checked) {
  //     // Get the current filtered data from the table
  //     const currentFilteredData = accessCodeList.filter(record => {
  //       // Check if record passes ALL active filters
  //       return Object.entries(filteredInfo).every(([key, filterValue]) => {
  //         // Skip if no filter value or no filter function
  //         if (!filterValue || !columns.find(col => col.dataIndex === key)?.onFilter) {
  //           return true;
  //         }

  //         // Get the filter function for this column
  //         const filterFn = columns.find(col => col.dataIndex === key).onFilter;
  //         // Apply the filter
  //         return filterFn(filterValue, record);
  //       });
  //     });

  //     // Set selections based on filtered data
  //     setSelects(currentFilteredData.map(record => record.userId));
  //     setSelectsRec(currentFilteredData);
  //   } else {
  //     setSelects([]);
  //     setSelectsRec([]);
  //   }
  //   setSelectAll(checked);
  // };

  const handleSelectAll = (checked) => {
    if (checked) {
      let ids = filteredData?.length
        ? filteredData?.map((i) => i?.userId)
        : accessCodeList?.map((i) => i?.userId);

      setSelects(ids);

      setSelectsRec(filteredData?.length ? filteredData : accessCodeList);

      // Get the current filtered data from the table
      // const currentFilteredData = accessCodeList.filter(record => {
      //   // Apply all current filters
      //   return Object.entries(filteredInfo).every(([key, filterValue]) => {

      //     // Skip if no filter value or no filter function
      //     if (!filterValue || !columns.find(col => col.dataIndex === key)?.onFilter) {
      //       return true;
      //     }

      //     // Special handling for percentage column
      //     if (key === 'percentage') {

      //       return record?.percentage != null && record?.percentage.toString() == filterValue;
      //     }
      //     if (key === 'round2') {

      //       return record?.round2 != null && record?.round2.toString() == filterValue;
      //     }

      //     // Get the filter function for this column
      //     const filterFn = columns.find(col => col.dataIndex === key).onFilter;
      //     // Apply the filter
      //     return filterFn(filterValue, record);
      //   });
      // });

      // // Set selections based on filtered data
      // setSelects(currentFilteredData.map(record => record.userId));
      // setSelectsRec(currentFilteredData);
    } else {
      setSelects([]);
      setSelectsRec([]);
    }
    setSelectAll(checked);
  };

  const handleGetNotes = (codeId, userId) => {

    setIsAddNotes(true)

    simpleGetCallWithErrorResponse(ApiConfig.GET_NOTES + `userId=${userId}&codeid=${codeId}`).then((res) => {

      if (res?.json?.succeded) {
        setNotes(res?.json?.response)
      }

    })

  }



  const columns = [
    // {
    //   // title: "Select",
    //   fixed: 'left',
    //   width: 40,
    //   title: () => (
    //     <input
    //       type="checkbox"
    //       checked={selectAll}
    //       onChange={(e) => handleSelectAll(e.target.checked)}
    //     />
    //   ),
    //   dataIndex: "id",
    //   render: (text, record) => (
    //     <input
    //       type="checkbox"
    //       checked={selects.includes(record.userId)}
    //       // disabled={record.status === "Rejected"}
    //       onChange={(e) => handleSelect(record, e.target.checked)}
    //     />
    //   ),
    // },
    // {
    //   title: "Name",
    //   dataIndex: "name",
    //   fixed: 'left',
    //   width: 110,
    //   sorter: (a, b) => a.name?.localeCompare(b.name),
    //   // filters: _.uniqWith(
    //   //   filterData(accessCodeList)((i) => i.name),
    //   //   _.isEqual
    //   // ),
    //   // filterSearch: true,
    //   filteredValue: filteredInfo.name || null,
    //   onFilter: (value, record) =>
    //     value === ""
    //       ? record.name.toString().toLowerCase() === value.toLowerCase()
    //       : record.name.toString().toLowerCase().includes(value.toLowerCase()),
    // },
    // {
    //   title: () => (
    //     <div style={{ display: 'flex', alignItems: 'center' }}>
    //       <input
    //         type="checkbox"
    //         defaultValue={false}
    //         checked={filteredData?.length > 0 ? filteredData.length === selectsRec?.length:selectAll}
    //         onChange={(e) =>{  handleSelectAll(e.target.checked)}}
    //       />
    //       <span style={{ marginLeft: 8 }}>Name</span>
    //     </div>
    //   ),
    //   fixed: 'left',
    //   width: 150, // Adjust the width as necessary
    //   render: (text, record) => {
    //     const truncatedText = record.name?.length > 10 ? record.name?.slice(0, 15) + "..." : record.name;
    //     return (
    //     <div style={{ display: 'flex', alignItems: 'center' }}>
    //       <input
    //         type="checkbox"
    //         checked={selects.includes(record.userId)}
    //         onChange={(e) => handleSelect(record, e.target.checked)}
    //       />

    //       <span style={{ marginLeft: 8, textWrap:"nowrap" }}>{truncatedText}</span>
    //     </div>
    //     )
    //   },
    //   // sorter: (a, b) => a.name?.localeCompare(b.name),
    //   filteredValue: filteredInfo.name || null,
    //   onFilter: (value, record) =>
    //     value === ""
    //       ? record.name.toString().toLowerCase() === value.toLowerCase()
    //       : record.name.toString().toLowerCase().includes(value.toLowerCase()),
    // },

    {
      title: () => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            defaultValue={false}
            checked={
              filteredData?.length > 0
                ? filteredData.length === selectsRec?.length
                : selectAll
            }
            onChange={(e) => {
              handleSelectAll(e.target.checked);
            }}
          />
          <span style={{ marginLeft: 8 }}>Name</span>
        </div>
      ),
      fixed: "left",
      width: 150,
      render: (text, record, index) => {
        const truncatedText =
          record.name?.length > 12
            ? record.name?.slice(0, 12) + "..."
            : record.name;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={selects.includes(record.userId)}
              onChange={(e) => handleSelect(record, e.target.checked)}
            />

            <Tooltip title={record.name} placement="top">

              <span
                style={{
                  marginLeft: 5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between", // pushes name and icon apart
                  width: "100px", // set a fixed or max width as needed
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  setShowLog(true);
                  setUserId(record?.userId);
                  setUserName(record?.name);
                }}
              >
                <span>{truncatedText}</span>

                {
                  record?.haveNote && <img
                    src={cardtext}
                    onClick={(e) => {
                      e.stopPropagation()
                      setUserId(record?.userId);
                      setUserName(record?.name);
                      handleGetNotes(record?.id, record?.userId)
                    }}
                    style={{ width: "12px", backgroundColor: "white", color: "black" }}
                  />
                }


              </span>

            </Tooltip>
          </div>
        );
      },
      // sorter: (a, b) => a.name?.localeCompare(b.name),
      filteredValue: filteredInfo.name || null,
      onFilter: (value, record) =>
        value === ""
          ? record.name.toString().toLowerCase() === value.toLowerCase()
          : record.name.toString().toLowerCase().includes(value.toLowerCase()),
    },

    {
      title: "Phone",
      dataIndex: "phoneNumber",
      // fixed: 'left',
      sorter: (a, b) => a.phoneNumber?.localeCompare(b.phoneNumber),
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.phoneNumber
        ),
        _.isEqual
      ),
      // filterSearch: true,
      filteredValue: filteredInfo.phoneNumber || null,
      onFilter: (value, record) =>
        value === ""
          ? record.phoneNumber?.toString() === value
          : record.phoneNumber?.toString().includes(value),
    },
    {
      title: "Email",
      dataIndex: "emailId",
      // fixed: 'left',
      sorter: (a, b) => a.emailId?.localeCompare(b.emailId),
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.emailId
        ),
        _.isEqual
      ),
      // filterSearch: true,
      filteredValue: filteredInfo.emailId || null,
      onFilter: (value, record) =>
        value == ""
          ? record.emailId?.toString()?.toLowerCase() === value.toLowerCase()
          : record.emailId
            ?.toString()
            ?.toLowerCase()
            .includes(value.toLowerCase()),
    },
    // {
    //   title: "Ed. Level",
    //   dataIndex: "educationLevel",
    //   width:100,
    //   sorter: (a, b) => a.educationLevel?.localeCompare(b.educationLevel),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.educationLevel),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.educationLevel || null,
    //   onFilter: (value, record) => {
    //     if (!value || !record.educationLevel) return false;
    //     return record.educationLevel.startsWith(value);
    //   },

    //   filterSearch: true,
    // },
    {
      title: "Ed. Level",
      dataIndex: "educationLevel",
      width: 100,
      sorter: (a, b) => a.educationLevel?.localeCompare(b.educationLevel),
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.educationLevel || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.educationLevel || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.educationLevel;
        }
        return record.educationLevel?.startsWith(value);
      },
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 13 ? (
            text.slice(0, 13) + "..."
          ) : (
            <span className="text-nowrap">{text}</span>
          );
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer", textWrap: "nowrap" }}>
              {truncatedText}
            </span>
          </Tooltip>
        );
      },
    },

    {
      title: "Ed. Area",
      width: 100,
      dataIndex: "feildOfEducation",
      sorter: (a, b) => a.feildOfEducation?.localeCompare(b.feildOfEducation),
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.feildOfEducation || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.feildOfEducation || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.feildOfEducation;
        }
        if (!value || !record.feildOfEducation) return false;
        return record.feildOfEducation.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record?.feildOfEducation === null
      //     ? record.feildOfEducation == null
      //     : record.feildOfEducation?.startsWith(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 10 ? text.slice(0, 10) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Exp (Yr)",
      dataIndex: "experience",
      width: 85,
      sorter: (a, b) => a.experience - b.experience,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.experience || "0"
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.experience || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.experience;
        }
        return record.experience == value;
      },
      filterSearch: true,
      render: (text) => text,
    },

    {
      title: "Current Title",
      width: 110,
      dataIndex: "roleName",
      sorter: (a, b) => a.roleName?.length - b.roleName?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.roleName || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.roleName || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.roleName;
        }
        if (!value || !record.roleName) return false;
        return record.roleName.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.roleName === null
      //     ? record.roleName === null
      //     : record.roleName?.startsWith(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 10 ? text.slice(0, 10) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Current Company",
      dataIndex: "currentCompany",
      width: 140,
      sorter: (a, b) => a.currentCompany?.length - b.currentCompany?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.currentCompany || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.currentCompany || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.currentCompany;
        }
        if (!value || !record.currentCompany) return false;
        return record.currentCompany.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.currentCompany === null
      //     ? record.currentCompany === null
      //     : record.currentCompany?.startsWith(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 15 ? text.slice(0, 15) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Current Company",
    //   dataIndex: "currentCompany",
    //   sorter: (a, b) => a.currentCompany?.length - b.currentCompany?.length,
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.currentCompany),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.currentCompany || null,
    //   onFilter: (value, record) =>
    //     record.currentCompany === null
    //       ? record.currentCompany === null
    //       : record.currentCompany?.startsWith(value),
    //   filterSearch: true,
    // },

    {
      title: "Current Industry",
      dataIndex: "currentIndustry",
      width: 140,
      sorter: (a, b) => a.currentIndustry - b.currentIndustry,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.currentIndustry || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.currentIndustry || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.currentIndustry;
        }
        if (!value || !record.currentIndustry) return false;
        return record.currentIndustry.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.currentIndustry == null
      //     ? record.currentIndustry == null
      //     : record.currentIndustry?.includes(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 15 ? text.slice(0, 15) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      width: 140,
      sorter: (a, b) => {
        const valA = a.departmentName || "N/A";
        const valB = b.departmentName || "N/A";

        // Place "N/A" at the top
        if (valA === "N/A") return -1;
        if (valB === "N/A") return 1;

        return valB.localeCompare(valA); // reverse order
      },
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.departmentName || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.departmentName || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.departmentName;
        }
        if (!value || !record.departmentName) return false;
        return record.departmentName.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.currentIndustry == null
      //     ? record.currentIndustry == null
      //     : record.currentIndustry?.includes(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 10 ? text.slice(0, 10) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Location",
      dataIndex: "currentLocation",
      width: 140,
      sorter: (a, b) => {
        const valA = a.currentLocation || "N/A";
        const valB = b.currentLocation || "N/A";

        // Place "N/A" at the top
        if (valA === "N/A") return -1;
        if (valB === "N/A") return 1;

        return valB.localeCompare(valA); // reverse order
      },
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.currentLocation || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.currentLocation || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.currentLocation;
        }
        if (!value || !record.currentLocation) return false;
        return record.currentLocation.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.currentIndustry == null
      //     ? record.currentIndustry == null
      //     : record.currentIndustry?.includes(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 10 ? text.slice(0, 10) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Salary Exp.",
    //   dataIndex: "expectedCTC",
    //   sorter: (a, b) => a.expectedCTC?.length - b.expectedCTC?.length,
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.expectedCTC),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.expectedCTC || null,
    //   render: (text, record) => (
    //     <div style={{ whiteSpace: 'nowrap' }}>
    //       {text}
    //     </div>
    //   ),
    //   onFilter: (value, record) =>
    //     record.expectedCTC === null
    //       ? record?.expectedCTC === null
    //       : record.expectedCTC?.startsWith(value),
    //       render: (text) => {
    //         if (!text) return null;
    //         const truncatedText = text.length > 15 ? text.slice(0, 11) + '...' : text;
    //         return (
    //           <Tooltip title={text}>
    //             <span style={{ cursor: 'pointer' }}>{truncatedText}</span>
    //           </Tooltip>
    //         );
    //       }
    // },
    {
      title: "Salary Exp.",
      dataIndex: "expectedCTC",
      width: 110,
      sorter: (a, b) => a.expectedCTC?.length - b.expectedCTC?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.expectedCTC || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.expectedCTC || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.expectedCTC;
        }
        if (!value || !record.expectedCTC) return false;
        return record.expectedCTC.startsWith(value);
      },
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 15 ? text.slice(0, 11) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Available By",
      dataIndex: "availableDate",
      width: 100,
      sorter: (a, b) => new Date(a?.availableDate) - new Date(b?.availableDate),
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => formatDate(i?.availableDate)
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.availableDate || null,
      filterSearch: true,
      onFilter: (value, record) => {
        if (value === "" || value === null) {
          return !record.availableDate;
        }
        return formatDate(record.availableDate).includes(value);
      },

      render: (text) => formatDate(text) || "" || null,
    },
    {
      title: "Buy Out",
      dataIndex: "noticePeriodBuyoption",
      width: 70,
      sorter: (a, b) => a.noticePeriodBuyoption - b.noticePeriodBuyoption,
      filters: Array.from(
        new Set(
          (filteredData.length > 0 ? filteredData : accessCodeList)
            .map(item => item.noticePeriodBuyoption)
        )
      ).map(v => ({
        text: v === true ? "Yes" : v === false ? "No" : " ",
        value: v
      })),

      filteredValue: filteredInfo.noticePeriodBuyoption || null,
      onFilter: (value, record) => record.noticePeriodBuyoption === value,
      filterSearch: true,
      render: (value) =>
        value === true ? "Yes" :
          value === false ? "No" :
            " ",
    },
    {
      title: "Custom Q.1",
      dataIndex: "customQuestion1",
      width: 100,
      sorter: (a, b) => a?.customQuestion1?.length - b?.customQuestion1?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i["customQuestion1"]
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo["customQuestion1"] || null,
      onFilter: (value, record) => {
        if (record["customQuestion1"]) {
          return record["customQuestion1"].startsWith(value);
        }
        return record["customQuestion1"] === null;
      },
      hidden: !customQuestion[0] || customQuestion[0]?.questionText?.trim()?.length === 0,
      filterSearch: true,
      render: (text) =>
        text && text !== "N/A" ? (
          <Tooltip
            style={{ fontSize: "10px", background: "#fff" }}
            title={text === "N/A" ? "" : customQuestion[0]?.questionText}
          >
            <Tag
              className="border-0"
              style={{ fontSize: "10px", background: "#fff" }}
            >
              {text}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            className="border-0"
            style={{ fontSize: "10px", background: "#fff" }}
          >
            {text}
          </Tag>
        ),
    },
    {
      title: "Custom Q.2",
      dataIndex: "customQuestion2",
      width: 100,
      sorter: (a, b) => a?.customQuestion2?.length - b?.customQuestion2?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i["customQuestion2"]
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo["customQuestion2"] || null,
      onFilter: (value, record) => {
        if (record["customQuestion2"]) {
          return record["customQuestion2"].startsWith(value);
        }
        return record["customQuestion2"] === null;
      },
      hidden: !customQuestion[1] || customQuestion[1]?.questionText?.trim()?.length === 0,
      filterSearch: true,
      render: (text) =>
        text && text !== "N/A" ? (
          <Tooltip
            style={{ fontSize: "10px", background: "#fff" }}
            title={text === "N/A" ? "" : customQuestion[1]?.questionText}
          >
            <Tag
              className="border-0"
              style={{ fontSize: "10px", background: "#fff" }}
            >
              {text}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            className="border-0"
            style={{ fontSize: "10px", background: "#fff" }}
          >
            {text}
          </Tag>
        ),
    },
    {
      title: "Custom Q.3",
      dataIndex: "customQuestion3",
      width: 100,
      sorter: (a, b) => a?.customQuestion3?.length - b?.customQuestion3?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i["customQuestion3"]
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo["customQuestion3"] || null,
      onFilter: (value, record) => {
        if (record["customQuestion3"]) {
          return record["customQuestion3"].startsWith(value);
        }
        return record["customQuestion3"] === null;
      },
      hidden: !customQuestion[2] || customQuestion[2]?.questionText?.trim()?.length === 0,
      filterSearch: true,
      render: (text) =>
        text && text !== "N/A" ? (
          <Tooltip
            style={{ fontSize: "10px", background: "#fff" }}
            title={text === "N/A" ? "" : customQuestion[2]?.questionText}
          >
            <Tag
              className="border-0"
              style={{ fontSize: "10px", background: "#fff" }}
            >
              {text}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            className="border-0"
            style={{ fontSize: "10px", background: "#fff" }}
          >
            {text}
          </Tag>
        ),
    },
    {
      title: "Custom Q.4",
      dataIndex: "customQuestion4",
      width: 100,
      sorter: (a, b) => a?.customQuestion4?.length - b?.customQuestion4?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i["customQuestion4"]
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo["customQuestion4"] || null,
      onFilter: (value, record) => {
        if (record["customQuestion4"]) {
          return record["customQuestion4"].startsWith(value);
        }
        return record["customQuestion4"] === null;
      },
      hidden: !customQuestion[3] || customQuestion[3]?.questionText?.trim()?.length === 0,
      filterSearch: true,
      render: (text) =>
        text && text !== "N/A" ? (
          <Tooltip
            style={{ fontSize: "10px", background: "#fff" }}
            title={text === "N/A" ? "" : customQuestion[3]?.questionText}
          >
            <Tag
              className="border-0"
              style={{ fontSize: "10px", background: "#fff" }}
            >
              {text}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            className="border-0"
            style={{ fontSize: "10px", background: "#fff" }}
          >
            {text}
          </Tag>
        ),
    },
    {
      title: "Custom Q.5",
      dataIndex: "customQuestion5",
      width: 100,
      sorter: (a, b) => a?.customQuestion5?.length - b?.customQuestion5?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i["customQuestion5"]
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo["customQuestion5"] || null,
      onFilter: (value, record) => {
        if (record["customQuestion5"]) {
          return record["customQuestion5"].startsWith(value);
        }
        return record["customQuestion5"] === null;
      },
      hidden: !customQuestion[4] || customQuestion[4]?.questionText?.trim()?.length === 0,
      filterSearch: true,
      render: (text) =>
        text && text !== "N/A" ? (
          <Tooltip
            style={{ fontSize: "10px", background: "#fff" }}
            title={text === "N/A" ? "" : customQuestion[4]?.questionText}
          >
            <Tag
              className="border-0"
              style={{ fontSize: "10px", background: "#fff" }}
            >
              {text}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            className="border-0"
            style={{ fontSize: "10px", background: "#fff" }}
          >
            {text}
          </Tag>
        ),
    },
    {
      title: "Custom Q.6",
      dataIndex: "customQuestion6",
      width: 100,
      sorter: (a, b) => a?.customQuestion6?.length - b?.customQuestion6?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i["customQuestion6"]
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo["customQuestion6"] || null,
      onFilter: (value, record) => {
        if (record["customQuestion6"]) {
          return record["customQuestion6"].startsWith(value);
        }
        return record["customQuestion6"] === null;
      },
      hidden: !customQuestion[5] || customQuestion[5]?.questionText?.trim()?.length === 0,
      filterSearch: true,
      render: (text) =>
        text && text !== "N/A" ? (
          <Tooltip
            style={{ fontSize: "10px", background: "#fff" }}
            title={text === "N/A" ? "" : customQuestion[5]?.questionText}
          >
            <Tag
              className="border-0"
              style={{ fontSize: "10px", background: "#fff" }}
            >
              {text}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            className="border-0"
            style={{ fontSize: "10px", background: "#fff" }}
          >
            {text}
          </Tag>
        ),
    },
    // {
    //   title: "Available from",
    //   dataIndex: "availableDate",
    //   sorter: (a, b) => new Date(a?.availableDate) - new Date(b?.availableDate),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i?.availableDate?.split("T")[0]),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.availableDate || null,
    //   filterSearch: true,
    //   onFilter: (value, record) =>
    //     record.availableDate ? record.availableDate.includes(value) : false,
    //   render: (text) => text?.split("T")[0],
    // },

    // {
    //   title: "Pr. Personality",
    //   dataIndex: "primaryName",
    //   sorter: (a, b) => a.primaryName?.localeCompare(b.primaryName),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.primaryName),
    //     _.isEqual
    //   ).map((name) => name),
    //   filteredValue: filteredInfo.primaryName || null,
    //   onFilter: (value, record) => {
    //     if (record.primaryName) {
    //       return record.primaryName.startsWith(value);
    //     }
    //     return record.primaryName === null;
    //   },
    //   filterSearch: true,
    //   onCell: (record, rowIndex) => {
    //     return {
    //       onClick: (e) => {
    //         handleShow(record.primaryName);
    //       },
    //     };
    //   },
    //   render: (text, record) => (
    //     <>
    //       {text} {record.primaryMatch ? `(${record.primaryMatch})` : ""}
    //     </>
    //   ),
    // },

    {
      title: "Pr. Personality",
      width: 130,
      dataIndex: "primaryName",
      sorter: (a, b) => a.primaryName?.localeCompare(b.primaryName),
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.primaryName || " "
        ),
        _.isEqual
      )
        .map((name) => name)
        .filter((item) => item.value),
      filteredValue: filteredInfo.primaryName || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.primaryName;
        }
        if (!value || !record.primaryName) {
          return false;
        }
        return record.primaryName.startsWith(value);
      },
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.primaryName);
          },
        };
      },
      render: (text, record) => (
        <span className="text-nowrap">
          {text} {record.primaryMatch ? `(${record.primaryMatch})` : ""}
        </span>
      ),
    },

    {
      title: "Sec. Personality",
      width: 130,
      dataIndex: "secondaryName",
      sorter: (a, b) => a.secondaryName?.length - b.secondaryName?.length,

      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.secondaryName || " "
        ),
        _.isEqual
      )
        .map((name) => name)
        .filter((item) => item.value),
      filteredValue: filteredInfo.secondaryName || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.secondaryName;
        }
        return (
          record.secondaryName &&
          value &&
          record.secondaryName.startsWith(value)
        );

      },
      hidden: isShortAssement,
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.secondaryName, record.percentage);
          },
        };
      },
      render: (text, record) => (
        <>
          {text} {record.secondaryMatch ? `(${record.secondaryMatch})` : ""}
        </>
      ),
    },
    // {
    //   title: "Primary Match",
    //   dataIndex: "primaryMatch",
    //   sorter: (a, b) => parseInt(a?.primaryMatch) - parseInt(b?.primaryMatch),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.primaryMatch),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.primaryMatch || null,
    //   onFilter: (value, record) => {
    //     return record.primaryMatch == null
    //       ? record.primaryMatch === null
    //       : record.primaryMatch?.toString() === value?.toString();
    //   },
    //   filterSearch: true,
    // },
    // {
    //   title: "Secondary Match",
    //   dataIndex: "secondaryMatch",
    //   sorter: (a, b) => a.secondaryMatch?.length - b.secondaryMatch?.length,
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.secondaryMatch),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.secondaryMatch || null,
    //   onFilter: (value, record) => record.secondaryMatch?.startsWith(value),
    //   filterSearch: true,
    // },
    {
      title: "Personality",
      dataIndex: "personalityMatch",
      width: 110,
      sorter: (a, b) => a.personalityMatch?.length - b.personalityMatch?.length,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.personalityMatch || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.personalityMatch || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.personalityMatch;
        }
        if (record.personalityMatch) {
          return record.personalityMatch.startsWith(value);
        }
        return record.personalityMatch === null;
      },
      filterSearch: true,
      render: (text, record) => (
        <>
          {text && <>{text}</>}
          {/* {text} {record.percentage ? `(${record.percentage})` : ""} */}
        </>
      ),
    },
    {
      title: "Graph I (M)",
      dataIndex: "profile_1",
      width: 120,
      sorter: (a, b) => a.profile_1?.length - b.profile_1?.length,
      filters: _.uniqWith(
        (filteredData.length > 0 ? filteredData : accessCodeList).map((i) => ({
          text: i.profile_1 + ` (${i.preD_D})`,
          value: i.profile_1,
        })),
        _.isEqual
      ).filter((item) => item.value),
      filteredValue: filteredInfo.profile_1 || null,
      onFilter: (value, record) => {
        // Handle both single and multiple filter selections
        if (Array.isArray(value)) {
          return value.some((v) => record.profile_1?.startsWith(v));
        }
        return record.profile_1?.startsWith(value);
      },
      hidden: isShortAssement,
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.profile_1, record.percentage);
          },
        };
      },
      render: (text, record) => (
        <div style={{ width: '120px' }}>
          {record?.profile_1 == 'N/A' ? "" : record?.profile_1 + ` (${record?.preD_D})`}
        </div>
      ),
    }
    ,
    {
      title: "Graph II (L)",
      dataIndex: "profile_2",
      width: 100,
      sorter: (a, b) => a.profile_2?.length - b.profile_2?.length,
      filters: _.uniqWith(
        (filteredData.length > 0 ? filteredData : accessCodeList).map((i) => ({
          text: i.profile_2 + ` (${i.preD_M})`,
          value: i.profile_2,
        })),
        _.isEqual
      ).filter((item) => item.value),
      filteredValue: filteredInfo.profile_2 || null,
      onFilter: (value, record) => {
        // Handle both single and multiple filter selections
        if (Array.isArray(value)) {
          return value.some((v) => record.profile_2?.startsWith(v));
        }
        return record.profile_2?.startsWith(value);
      },
      hidden: isShortAssement,
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.profile_2, record.percentage);
          },
        };
      },
      render: (text, record) => (
        <div style={{ width: '100px' }}>
          {record?.profile_2 == 'N/A' ? "" : record?.profile_2 + ` (${record?.preD_M})`}
        </div>
      ),

    },
    {
      title: "Graph III (C)",
      dataIndex: "profile_3",
      width: 100,
      sorter: (a, b) => a.profile_3?.length - b.profile_3?.length,
      filters: _.uniqWith(
        (filteredData.length > 0 ? filteredData : accessCodeList).map((i) => ({
          text: i.profile_3 + ` (${i.preD_L})`,
          value: i.profile_3,
        })),
        _.isEqual
      ).filter((item) => item.value),
      filteredValue: filteredInfo.profile_3 || null,
      onFilter: (value, record) => {
        // Handle both single and multiple filter selections
        if (Array.isArray(value)) {
          return value.some((v) => record.profile_3?.startsWith(v));
        }
        return record.profile_3?.startsWith(value);
      },
      hidden: isShortAssement,
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.profile_3, record.percentage);
          },
        };
      },
      render: (text, record) => (

        <div style={{
          width: '120px',
          position: 'relative',
          paddingRight: '18px'   // to avoid text overlapping the icon
        }}>
          <span>
            {record?.profile_3 === 'N/A' ? "" : `${record?.profile_3} (${record?.preD_L})`}
          </span>

          {record?.candidatePersonalityReportFile && (
            <img
              src={detailedPersonalityIcon}
              style={{
                width: '12px',
                height: '12px',
                position: 'absolute',
                right: '0px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer'
              }}
              onClick={(e) => {
                e.stopPropagation();
                window.open(record?.candidatePersonalityReportFile);
              }}
            />
          )}
        </div>


      ),

    },
    // {
    //   title: "Application",
    //   dataIndex: "applicationMatch",
    //   width: 110,
    //   sorter: (a, b) => a.applicationMatch?.length - b.applicationMatch?.length,
    //   filters: _.uniqWith(
    //     filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
    //       (i) => i.applicationMatch
    //     ),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.applicationMatch || null,
    //   onFilter: (value, record) => {
    //     if (record.applicationMatch) {
    //       return record.applicationMatch.startsWith(value);
    //     }
    //     return record.applicationMatch === null;
    //   },
    //   filterSearch: true,
    //   render: (text, record) => <>{text}</>,
    // },
    // {
    //   title: "App Complete %",
    //   dataIndex: "percentage",
    //   width: 120,
    //   sorter: (a, b) => parseInt(a.percentage) - parseInt(b.percentage),
    //   filters: _.uniqWith(
    //     filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
    //       (i) => (i.percentage != null ? i?.percentage?.toString() : "")
    //     ),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo?.percentage || null,
    //   onFilter: (value, record) =>
    //     record?.percentage != null && record?.percentage.toString() === value,
    //   filterSearch: true,
    // },
    // {
    //   title: "Prof Complete %",
    //   dataIndex: "profileFilledPercentage",
    //   width: 120,
    //   sorter: (a, b) => parseInt(a.percentage) - parseInt(b.percentage),
    //   filters: _.uniqWith(
    //     filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
    //       (i) =>
    //         i.profileFilledPercentage != null
    //           ? i?.profileFilledPercentage?.toString()
    //           : ""
    //     ),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo?.profileFilledPercentage || null,
    //   onFilter: (value, record) =>
    //     record?.profileFilledPercentage != null &&
    //     record?.profileFilledPercentage.toString() === value,
    //   filterSearch: true,
    // },
    {
      title: "App. Date",
      render: (record) => record,
      dataIndex: "dateOfCompletion",
      sorter: (a, b) => {
        a.dateOfCompletion =
          a.dateOfCompletion === null ? "" : a.dateOfCompletion;
        b.dateOfCompletion =
          b.dateOfCompletion === null ? "" : b.dateOfCompletion;

        return a?.dateOfCompletion.localeCompare(b?.dateOfCompletion);
      },
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.dateOfCompletion
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.dateOfCompletion || null,
      filterSearch: true,
      onFilter: (value, record) => {
        if (value === "" || value === null) {
          return !record.dateOfCompletion;
        }
        return record.dateOfCompletion?.startsWith(value);
      },
    },
    // {
    //   title: "Round 2",
    //   dataIndex: "round2",
    //   width: 100,
    //   sorter: (a, b) => {
    //     // Handle null/undefined values in sorting
    //     if (!a.round2) return -1;
    //     if (!b.round2) return 1;
    //     return a.round2.localeCompare(b.round2);
    //   },
    //   filters: _.uniqWith(
    //     filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
    //       (i) => i.round2
    //     ),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.round2 || null,
    //   onFilter: (value, record) => {
    //     // if (value === "Not Started") {
    //     //     return !record.round2;
    //     // }
    //     return record.round2 === value;
    //   },
    //   filterSearch: true,
    //   render: (text) => text,
    // },
    {
      title: "Quiz Score",
      dataIndex: "quizScore",
      sorter: (a, b) => {
        // Handle null/undefined values in sorting
        if (!a.quizScore) return -1;
        if (!b.quizScore) return 1;
        return a.quizScore.localeCompare(b.quizScore);
      },
      width: 80,
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.quizScore
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.quizScore || null,
      filterSearch: true,
      onFilter: (value, record) => {
        if (value === "") {
          return !record.quizScore;
        }
        return record.quizScore === value;
      },
    },
    // {
    //   title: "Resume",
    //   width:70,
    //   render: (record) => {
    //     if(record.resume===null){
    //       return ;
    //     }
    //     return (
    //       <a
    //         href={record.resume}
    //         download
    //         target="_blank"
    //         alt=""
    //         rel="noopener noreferrer"
    //       >
    //         Resume
    //       </a>
    //     );
    //   },
    // },
    // {
    //   title: "Resume",
    //   width: 70,
    //   render: (record) => {
    //     if (!record.resume) {
    //       return null; // Return null instead of undefined for clarity
    //     }
    //     return (
    //       <a
    //         href={record.resume}
    //         download
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         aria-label="Download Resume" // Added for accessibility
    //       >
    //         Resume
    //       </a>
    //     );
    //   },
    // },
    {
      title: "Resume",
      width: 70,
      render: (record) => {
        if (!record.resume) {
          return null;
        }
        return (
          <a href={record.resume} target="_blank" rel="noopener noreferrer">
            Resume
          </a>
        );
      },
    },
    {
      title: "Assigned Tags",
      dataIndex: "tags",

      sorter: (a, b) => {
        const aVal = a.tags?.[0]?.status || "";
        const bVal = b.tags?.[0]?.status || "";
        return aVal.localeCompare(bVal);
      },


      filters: _.uniq(
        accessCodeList
          .flatMap((item) => item.tags?.map((t) => t.status) || [])
          .filter(Boolean)
      ).map((tag) => ({
        text: tag,
        value: tag,
      })),

      filteredValue: filteredInfo.tags || null,

      onFilter: (value, record) => {
        if (Array.isArray(record.tags)) {
          return record.tags.some((t) => t.status === value);
        }
        return false;
      },

      filterSearch: true,

      render: (text, record) => {
        const tags = record.tags || [];
        if (!tags.length) return <span>-</span>;

        const first = tags[0]?.status;
        const more = tags.length - 1;

        return (
          <Tooltip title={tags.map((i) => i.status).join(", ")}>
            <div style={{ whiteSpace: "nowrap" }}>
              {first} {more > 0 && <span style={{ color: "#888" }}>+{more}</span>}
            </div>
          </Tooltip>
        );
      },
    }



    // {
    //   title: "Assign Tags",
    //   dataIndex: "status",
    //   sorter: (a, b) => {
    //     // Handle null/undefined values in sorting
    //     if (!a.round2) return -1;
    //     if (!b.round2) return 1;
    //     return a.round2.localeCompare(b.round2);
    //   },
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)(
    //       (i) => i.status
    //     ),
    //     _.isEqual
    //   ),

    //   filteredValue: filteredInfo.status || null,
    //   onFilter: (value, record) => {
    //     if (record.status) {
    //       return record.status.includes(value);
    //     }
    //     return record.status === null;
    //   },
    //   filterSearch: true,
    //   render: (text, record) => (
    //     <div style={{ whiteSpace: "nowrap" }}>{text}</div>
    //   ),
    // },
    // {
    //   title: "Completed %",
    //   dataIndex: "percentage",
    //   sorter: (a, b) => parseInt(a.percentage) - parseInt(b.percentage),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) =>
    //       i.percentage != null ? i?.percentage?.toString() : ""
    //     ),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo?.percentage || null,
    //   onFilter: (value, record) =>
    //     record?.percentage != null && record?.percentage.toString() === value,
    //   filterSearch: true,
    // },

    // {
    //   title: "Delete",
    //   width: 50,

    //   render: (value, record) => {
    //     return (
    //       <img
    //         src={trashIcon}
    //         className="border-0"
    //         target="_blank"
    //         alt=""
    //         rel="noopener noreferrer"
    //         // onClick={() => downloadExcel(record.userId)}
    //         onClick={() => deleteRecord(value?.userId, value)}
    //       ></img>
    //     );
    //   },
    // }
    ,
    {
      title: "Actions",
      dataIndex: "actions",
      fixed: "right",
      render: (_, record) => (
        <div className="dropdown">
          <img
            src={threeDots}
            alt="Actions"
            type="button"
            // id={`dropdownMenuButton-${record.key}`}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style={{ cursor: "pointer" }}
          />
          <div
            className="dropdown-menu dropdown-menu-end"
            aria-labelledby={`dropdownMenuButton-${record.key}`} style={{ padding: "2px", marginRight: "50px" }}
          >
            {/* <a
              className="dropdown-item"
              onClick={() => {
                console.log(record);
                handleActiveDeActiveCode(record?.isActive, record?.code);
              }}
            >
              {record?.isActive ? "InActive" : "Active"}
            </a> */}
            {/* <a
              className="dropdown-item"
              onClick={() => {

                getDataForEdit(record?.key)
              }}
            >
              Clone
            </a> */}


            {/* <a
              className="dropdown-item"
              onClick={() => {
                // getDataForEdit(record?.id, record.code, true);
              }}
            >
              Edit
            </a> */}

            <a
              className="dropdown-item"
              onClick={() => deleteRecord(record?.userId, record)}
              style={{ padding: "2px 6px", fontSize: '14px' }}
            >
              Delete
            </a>
            <a
              className="dropdown-item"
              onClick={() => {
                setIsAddNotes(true)
                handleGetNotes(record?.id, record?.userId)
                setUserId(record?.userId);
                setUserName(record?.name);
              }}
              style={{ padding: "2px 6px", fontSize: '14px' }}
            >
              Add Notes
            </a>
            {
              record?.percentage === '100%' &&

              <a
                className="dropdown-item"
                // onClick={() => (true)}
                style={{ padding: "2px 6px", fontSize: '14px' }}
                onClick={() => {

                  if (!record?.aiSummary) {

                    toastMsg('error', 'Candidate Summary not processed , please come after some time.')

                    PostCallWithErrorResponse(ApiConfig?.REQUEST_SUMMARY_REPORT + `userid=${record?.userId}&code=${code}`)

                    return
                  }

                  navigate(`/candidateDashboard/${code}/${record?.userId}`)


                }}
              >
                Candidate Summary Report
              </a>

            }
            {
              (record?.percentage === '100%' && !isShortAssement) &&
              <a
                className="dropdown-item"
                onClick={() => {

                  navigate('/personalityReport')
                  return
                  if (record?.candidatePersonalityReportFile) {
                    window.open(record?.candidatePersonalityReportFile)
                    return
                  }


                  setIsShowCandidateReport(true)
                  setUserName(record?.name)
                  setUserId(record?.userId)
                }}
                style={{ padding: "2px 6px", fontSize: '14px' }}
              >
                {record?.candidatePersonalityReportFile ? "" : "Generate"} Detailed Personality Report
              </a>
            }




          </div>
        </div >
      ),
    }
    // {
    //   title: "Download",
    //   // hidden: adminData?.admin !== "Admin",
    //   width: 70,
    //   render: (value, record) => {
    //     return (
    //       <img
    //         src={downloadicon}
    //         className="border-0"
    //         target="_blank"
    //         alt=""
    //         rel="noopener noreferrer"
    //         onClick={() => downloadExcelfile(record?.userId)}
    //       ></img>
    //     );
    //   },
    // },
  ].filter((i) => i?.hidden != true);
  const column1 = [
    // {
    //   title: "Date of Completion",
    //   render: (record) => record?.dateOfCompletion,
    // },
    // {
    //   title: "Date of Completion",
    //   render: (record) => record,
    //   dataIndex: "dateOfCompletion",
    //   sorter: (a, b) => {
    //     a.dateOfCompletion =
    //       a.dateOfCompletion === null ? "" : a.dateOfCompletion;
    //     b.dateOfCompletion =
    //       b.dateOfCompletion === null ? "" : b.dateOfCompletion;

    //     return a?.dateOfCompletion.localeCompare(b?.dateOfCompletion);
    //   },
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.dateOfCompletion),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.dateOfCompletion || null,
    //   filterSearch: true,
    //   onFilter: (value, record) => record.dateOfCompletion?.startsWith(value),
    // },
    {
      // title: "Select",
      // fixed: 'left',
      width: 10,
      title: () => (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      dataIndex: "id",
      render: (text, record) => (
        <input
          type="checkbox"
          checked={selects.includes(record.userId)}
          // disabled={record.status === "Rejected"}
          onChange={(e) => handleSelect(record, e.target.checked)}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      // fixed: 'left',
      // width:150,
      sorter: (a, b) => a.name?.localeCompare(b.name),
      // filters: _.uniqWith(
      //   filterData(accessCodeList)((i) => i.name),
      //   _.isEqual
      // ),
      // filterSearch: true,
      filteredValue: filteredInfo.name || null,
      render: (text, record) => {
        return <span style={{
          //  marginLeft: 8, 
          whiteSpace: "nowrap"
        }}
          onClick={() => {
            setShowLog(true)
            setUserId(record?.userId)
            setUserName(record?.name)
          }}
        >
          {record?.name}
        </span>
      },

      onFilter: (value, record) =>
        value === ""
          ? record.name === ""
          : record.name.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber?.localeCompare(b.phoneNumber),
      // filters: _.uniqWith(
      //   filterData(accessCodeList)((i) => i.phoneNumber),
      //   _.isEqual
      // ),
      // filterSearch: true,
      filteredValue: filteredInfo.phoneNumber || null,
      onFilter: (value, record) =>
        value === ""
          ? record.phoneNumber === value
          : record.phoneNumber
            ?.toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    },
    {
      title: "Email",
      dataIndex: "emailId",
      sorter: (a, b) => a.emailId?.localeCompare(b.emailId),
      // filters: _.uniqWith(
      //   filterData(accessCodeList)((i) => i.emailId),
      //   _.isEqual
      // ),
      // filterSearch: true,
      filteredValue: filteredInfo.emailId || null,
      onFilter: (value, record) =>
        record.emailId.toString().toLowerCase().includes(value.toLowerCase()),
    },
    // {
    //   title: "Ed. Level",
    //   dataIndex: "educationLevel",
    //   sorter: (a, b) => a.educationLevel?.localeCompare(b.educationLevel),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.educationLevel),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.educationLevel || null,
    //   onFilter: (value, record) => {
    //     if (!value || !record.educationLevel) return false;
    //     return record.educationLevel.startsWith(value);
    //   },

    //   filterSearch: true,
    //   hidden: type === "Investor" || type === "Individual User",
    // },
    // {
    //   title: "Ed. Level",
    //   dataIndex: "educationLevel",
    //   sorter: (a, b) => a.educationLevel?.localeCompare(b.educationLevel),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.educationLevel || " "),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.educationLevel || null,
    //   onFilter: (value, record) => {
    //     if (value === " ") {
    //       return !record.educationLevel;
    //     }
    //     return record.educationLevel?.startsWith(value);
    //   },
    //   filterSearch: true,
    //   render: (text) => text || " ",
    // },

    // {
    //   title: "Ed. Area",
    //   dataIndex: "feildOfEducation",
    //   sorter: (a, b) => a.feildOfEducation?.localeCompare(b.feildOfEducation),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) => i.feildOfEducation || " "),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.feildOfEducation || null,
    //   onFilter: (value, record) => {
    //     if (value === " ") {
    //       return !record.feildOfEducation;
    //     }
    //     if (!value || !record.feildOfEducation) return false;
    //     return record.feildOfEducation.startsWith(value);
    //   },
    //   // onFilter: (value, record) =>
    //   //   record?.feildOfEducation === null
    //   //     ? record.feildOfEducation == null
    //   //     : record.feildOfEducation?.startsWith(value),
    //   filterSearch: true,
    //   render: (text) => {
    //     if (!text) return null;
    //     const truncatedText =
    //       text.length > 10 ? text.slice(0, 10) + "..." : text;
    //     return (
    //       <Tooltip title={text}>
    //         <span style={{ cursor: "pointer" }}>{truncatedText}</span>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      title: "Department",
      dataIndex: "departmentName",
      width: 140,
      sorter: (a, b) => {
        const valA = a.currentLocation || "N/A";
        const valB = b.currentLocation || "N/A";

        // Place "N/A" at the top
        if (valA === "N/A") return -1;
        if (valB === "N/A") return 1;

        return valB.localeCompare(valA); // reverse order
      },
      filters: _.uniqWith(
        filterData(filteredData.length > 0 ? filteredData : accessCodeList)(
          (i) => i.departmentName || " "
        ),
        _.isEqual
      ),
      filteredValue: filteredInfo.departmentName || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.departmentName;
        }
        if (!value || !record.departmentName) return false;
        return record.departmentName.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.currentIndustry == null
      //     ? record.currentIndustry == null
      //     : record.currentIndustry?.includes(value),
      filterSearch: true,
      render: (text) => {
        if (!text) return null;
        const truncatedText =
          text.length > 15 ? text.slice(0, 15) + "..." : text;
        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{truncatedText}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Exp(Yr)",
      dataIndex: "experience",
      sorter: (a, b) => a.experience - b.experience,
      filters: _.uniqWith(
        filterData(accessCodeList)((i) => i?.experience),
        _.isEqual
      ),

      filteredValue: filteredInfo.experience || null,
      onFilter: (value, record) => record.experience == value,
      filterSearch: true,
      hidden: type != "Internal Assessment",
    },
    {
      title: "Current Title",
      dataIndex: "roleName",
      sorter: (a, b) => a.roleName?.length - b.roleName?.length,
      filters: _.uniqWith(
        filterData(accessCodeList)((i) => i.roleName || " "),
        _.isEqual
      ),
      filteredValue: filteredInfo.roleName || null,
      onFilter: (value, record) => {
        if (value === " ") {
          return !record.roleName;
        }
        if (!value || !record.roleName) return false;
        return record.roleName.startsWith(value);
      },
      // onFilter: (value, record) =>
      //   record.roleName === null
      //     ? record.roleName === null
      //     : record.roleName?.startsWith(value),
      filterSearch: true,
    },

    {
      title: "Pr. Personality",
      dataIndex: "primaryName",
      sorter: (a, b) => a.primaryName?.localeCompare(b.primaryName),
      filters: _.uniqWith(
        filterData(accessCodeList)((i) => i.primaryName),
        _.isEqual
      ).map((name) => name),
      filteredValue: filteredInfo.primaryName || null,
      onFilter: (value, record) => {
        if (!value || !record.primaryName) {
          return false;
        }
        return record.primaryName.startsWith(value);
      },
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.primaryName, record.percentage);
          },
        };
      },
    },
    // render: (text, record) => (
    //   <>
    //     {text} {record.primaryMatch ? `(${record.primaryMatch})` : ""}
    //   </>
    // ),
    {
      title: "Sec. Personality",
      dataIndex: "secondaryName",
      sorter: (a, b) => a.secondaryName?.length - b.secondaryName?.length,
      filters: _.uniqWith(
        // Filter out null/empty values before creating unique filters
        filterData(accessCodeList.filter((i) => i?.secondaryName))(
          (i) => i.secondaryName
        ),
        _.isEqual
      ).filter((item) => item.value), // Remove any remaining empty filter options
      filteredValue: filteredInfo.secondaryName || null,
      onFilter: (value, record) => {
        // Only match records that have a secondaryName and match the filter value
        return (
          record.secondaryName &&
          value &&
          record.secondaryName.startsWith(value)
        );
      },
      hidden: isShortAssement,
      filterSearch: true,
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            handleShow(record.secondaryName, record.percentage);
          },
        };
      },
    },


    // {
    //   title: "Download",
    //   // hidden: adminData?.admin !== "Admin",
    //   width: 70,
    //   render: (value, record) => {
    //     return (
    //       <img
    //         src={downloadicon}
    //         className="border-0"
    //         target="_blank"
    //         alt=""
    //         rel="noopener noreferrer"
    //         onClick={() => downloadExcelfile(record?.userId)}
    //       ></img>
    //     );
    //   },
    // },

    {
      title: "Delete",
      width: 50,
      hidden: type === "Investor As Individual User",
      render: (value, record) => {
        return (
          <img
            src={trashIcon}
            className="border-0"
            target="_blank"
            alt=""
            rel="noopener noreferrer"
            // onClick={() => downloadExcel(record.userId)}
            onClick={() => deleteRecord(value?.userId, value)}
          ></img>
        );
      },
    },
    // {
    //   title: "Completed %",
    //   dataIndex: "percentage",
    //   sorter: (a, b) => parseInt(a.percentage) - parseInt(b.percentage),
    //   filters: _.uniqWith(
    //     filterData(accessCodeList)((i) =>
    //       i.percentage != null ? i.percentage.toString() : ""
    //     ),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.percentage || null,
    //   onFilter: (value, record) =>
    //     record.percentage != null && record.percentage.toString() === value,
    //   filterSearch: true,
    // },
  ].filter((i) => i?.hidden != true);

  const paginationConfig = {
    pageSizeOptions: [
      "10",
      "20",
      "30",
      "40",
      "50",
      "60",
      "70",
      "80",
      "90",
      "100",
    ],
    defaultPageSize: 50,
    showSizeChanger: false,
    onChange: (page, pageSize) => {
      console.log("Page:", page, "PageSize:", pageSize);
    },
  };

  const handleCloseLog = useCallback(() => {
    setShowLog(false)
  }, [userId])

  const downLoadList = () => {
    // console.log(allData);
    // const codeId = allData.map(x => x)[0].id;
    // console.log(codeId);

    if (code.length == 0 || downloadBtn) return;

    const mails = [];


    // if (selectsRec?.length > 0) {

    //   mails = selectsRec?.map((i) => i?.emailId);
    // } else {
    //   mails = filteredData?.length
    //     ? filteredData?.map((i) => i?.emailId)
    //     : accessCodeList?.map((i) => i?.emailId);
    // }

    if (selectsRec?.length > 0) {
      selectsRec.forEach((i) => {
        mails.push(i?.emailId);
      })
    } else if (filteredData.length > 0) {
      filteredData.forEach((i) => {
        mails.push(i?.emailId);
      });

    }

    else if (search.length > 0 || !isFilter || filteredData.length == 0) {

      accessCodeList.forEach((i) => {
        mails.push(i?.emailId);
      });
    }

    let filteredInfo = {
      emailId: mails,
      dateOfCompletion: null
    }

    // filteredInfo.emailId = mails;
    // filteredInfo.dateOfCompletion = null;

    setDownloadBtn(true);
    const param1 = code;
    const param2 = true;

    const url = `${ApiConfig.ACCESS_CODE_LIST}code=${param1}&export=${param2}&isActive=${isActive}`;
    console.log(filteredInfo);

    PostCallWithErrorResponse(url, filteredInfo)
      .then((res) => {
        if (res?.json?.status) {
          let data = res?.json;

          FileSaver.saveAs(
            "data:" + data?.contentType + ";base64," + data.data,
            data.fileName
          );
        } else {
          console.log(res);
        }

        setDownloadBtn(false);
      })
      .catch((err) => {
        console.log(err);

        setDownloadBtn(false);
      });
  };

  const filterDataByAll = (val) => {
    val = val.toLowerCase();

    let tr = val == "yes" ? true : val == "no" ? false : "";
    if (val.length > 0) {
      const fltr = accessCodeList?.filter((i) => {
        return (
          i?.name?.toLowerCase().includes(val) ||
          i?.emailId?.toLowerCase().includes(val) ||
          i?.phoneNumber?.includes(val) ||
          i?.educationLevel?.toLowerCase().includes(val) ||
          i?.feildOfEducation?.toLowerCase().includes(val) ||
          i?.roleName?.toLowerCase().includes(val) ||
          i?.currentCompany?.toLowerCase().includes(val) ||
          i?.currentIndustry?.toLowerCase().includes(val) ||
          i?.expectedCTC?.toLowerCase().includes(val) ||
          i?.percentage?.includes(val) ||
          i?.primaryName?.toLowerCase().includes(val) ||
          i?.secondaryName?.toLowerCase().includes(val) ||
          i?.primaryMatch?.includes(val) ||
          i?.secondaryMatch?.includes(val) ||
          i?.dateOfCompletion?.includes(val) ||
          i?.availableDate?.includes(val) ||
          i?.noticePeriodBuyoption === tr ||
          i?.personalityMatch?.toLowerCase().includes(val) ||
          i?.applicationMatch?.toLowerCase().includes(val) ||
          i?.round2?.toLowerCase().includes(val) ||
          i?.status?.toLowerCase().includes(val) ||
          i?.dateOfCompletion?.includes(val) ||
          i?.currentLocation?.toLowerCase().includes(val) ||
          i?.departmentName?.toLowerCase().includes(val) ||
          i?.profile_1?.toLowerCase().includes(val) ||
          i?.profile_2?.toLowerCase().includes(val) ||
          i?.profile_3?.toLowerCase().includes(val)
        );
      });

      setAccessCoeList(fltr);
    } else {


      if (filteredData?.length) {
        setAccessCoeList(filteredData)
      } else if (isFilter) {
        setAccessCoeList(accessCodeList)
      } else {

        setAccessCoeList(allData);
      }
    }
  };

  const filterByProfile = (type, val) => {
    if (val === "") {
      filterDataByAll(search);
      return;
    }

    if (type === "pri") {
      let filt = allData.filter((i) => {
        return i.primaryMatch == val + "%";
      });

      setAccessCoeList(filt);
    } else if (type == "sec") {
      let filt = allData.filter((i) => {
        return i.secondaryMatch == val + "%";
      });

      setAccessCoeList(filt);
    } else if (type == "both") {
      let filt = allData.filter((i) => {
        return i.secondaryMatch == val + "%" && i.primaryMatch == val + "%";
      });

      setAccessCoeList(filt);
    }
  };

  const [whatsApp, setWhatsApp] = useState(false);
  const [whatsAppRoundTwo, setWhatsAppRoundTwo] = useState(false);
  const [whatsAppRej, setWhatsAppRej] = useState(false);

  const [showApplication, setShowApplication] = useState(null);

  const [subject, setSubject] = useState("");
  const [from, setFrom] = useState("");

  const htmlContentData = (selReason, type = false) => {
    // console.log(code);

    PostCallWithErrorResponse(ApiConfig.GET_EMAIL_CONTENT, {
      codeid: code,
      reason: selReason,
      isDefault: type
    })
      .then((res) => {
        if (res) {
          console.log(res);
          setEmailContent(res?.json?.emailContent);
          setSubject(res?.json?.subject);
          setFrom(res?.json?.fromEmail);
        } else {
          console.log("err");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleShowApp = (app) => {


    setEmailContentType(app)

    setMailKey(app)
    if (app == 0) {
      setShowmail(true);
    } else {
      eclusionMails(app)
      setShowApplication(true);
    }
    htmlContentData(app);
  };
  const handleHideApp = () => {
    setShowApplication(false);
    setHoverTrue(false);
    setCcEmails([]);
    setWhatsApp(false);
    setStop(null);
    setFreq(null);
    setStopby(null);
    setSubject("");
    setIsDefaultEmailContent(false)
  };

  const [showRound2, setShowRound2] = useState(null);
  const handleShowRound = (app) => {
    setShowRound2(true);
    htmlContentData(app);
  };
  const handleHideRound = () => {
    setShowRound2(false);
    setHoverTrue(false);
    setCcEmails([]);
    setWhatsAppRoundTwo(false);
    setStop(null);
    setFreq(null);
    setStopby(null);
    setSubject("");
  };

  const [showMail, setShowmail] = useState(null);
  const [showWhatsapp, setShowWhatsapp] = useState(null);

  const [isGeneratingReport, setIsGenerRatingReport] = useState(false)
  const handleShowMail = (app) => {
    setShowmail(true);
    htmlContentData(app);
  };
  const handleHideMail = () => {
    setShowmail(false);
    setCcEmails([]);
    // setHoverTrue(false);
  };
  const handleHidewhatsapp = () => {
    setShowmail(false);
    setCcEmails([]);
    // setHoverTrue(false);
  };
  const handleShowWhatsapp = (app) => {
    setWhatsApp(true);
    htmlContentData(app);
  };
  const [reject, setReject] = useState(null);
  const handleShowReject = (app) => {
    setReject(true);
    htmlContentData(app);
  };
  const handleHideReject = () => {
    setReject(false);
    // setHoverTrue(false);
    setCcEmails([]);
    setWhatsAppRej(false);
    setStop(null);
    setFreq(null);
    setStopby(null);
  };

  const [showMailTest, setShowMailTest] = useState(null);
  const handleShowMailTest = () => {
    setShowMailTest(true);
  };
  const handleHideMailTest = () => {
    setShowMailTest(false);
  };

  const [testMsg, setTestMsg] = useState(null);
  const handleShowTestMsg = () => {
    setTestMsg(true);
  };
  const handleHideTestMsg = () => {
    setTestMsg(false);
    setPhoneMsg("");
  };
  const [testMsgRoundtwo, setTestMsgRoundtwo] = useState(null);
  const handleShowTestMsgRoundtwo = () => {
    setTestMsgRoundtwo(true);
  };
  const handleHideTestMsgRoundtwo = () => {
    setTestMsgRoundtwo(false);
    setPhoneMsg("");
  };
  const [phoneMsg, setPhoneMsg] = useState("");

  const [selects, setSelects] = useState([]);
  let [selectsRec, setSelectsRec] = useState([]);

  const [sortedCounts, setSortedCounts] = useState(0);
  const handleSelect = (record, checked) => {
    console.log(record);

    if (checked) {
      setSelects((prev) => [...prev, record.userId]);
      setSelectsRec((prev) => [...prev, record]);

      //setSortedCounts((prev => prev.filter(x => x.percentage !== "100%").length));
    } else {
      setSelects((prev) => prev.filter((id) => id !== record.userId));
      setSelectsRec((prev) =>
        prev.filter((item) => item.userId !== record.userId)
      );
    }
  };

  const handleSelectRejectStatus = (status) => {
    setShowSelectUser(false);
    setShowInProg(false);

    if (!selectsRec?.length) {
      toastMsg("error", "No users selected");
      return;
    }

    console.log(selectsRec);
    const codeJOB = selectsRec.map((x) => x.code)[0] + "" || "";
    console.log(codeJOB);

    PostCallWithErrorResponse(ApiConfig.SELECT_STATUS, {
      status: status === "select" ? 1 : status === "in-progress" ? 2 : 3,
      users: selectsRec.map((x) => ({
        userId: x.userId,
        codeId: x.id,
      })),
    })
      .then((res) => {
        if (res?.json?.response?.statusMessage) {
          toastMsg(
            "success",
            `${status === "select"
              ? "Selected successfully"
              : status === "in-progress"
                ? "In-progress successfully"
                : "Rejected Successfully"
            }`
          );
          // setSelectsRec([]);
          setSelects([]);
          setCcEmails([]);
        } else {
          toastMsg("error", "something went wrong");
        }
        getList(codeJOB);
      })
      .catch((err) => console.log(err));
  };

  const [hoverTrue, setHoverTrue] = useState(false);
  const [emailContent, setEmailContent] = useState("");

  const [freq, setFreq] = useState(null);
  const [stop, setStop] = useState(null);
  const [stopby, setStopby] = useState(null);

  const [ccEmails, setCcEmails] = useState([]);
  const [inputValue, setInputValue] = useState([]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const email = inputValue.trim();
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (email && isValidEmail && !ccEmails.includes(email)) {
        setCcEmails((prevEmails) => [...prevEmails, email]);
      } else {
        toastMsg("error", "Please enter valid email Id");
      }
      setInputValue("");
    }
  };
  const removeEmail = (emailToRemove) => {
    setCcEmails(ccEmails.filter((x) => x != emailToRemove));
  };
  // const [isSending, setIsSending] = useState(false);

  const eclusionMails = (type) => {

    let all = selectsRec.length

    selectsRec = selectsRec?.filter((i) => i?.status !== "Not Interested")

    let message = ''
    let filt = []
    if (type === 1 || type == 4 || type === 5 || type == 6) {


      if (type === 1) {

        filt = selectsRec.filter((i) => i.percentage !== "100%")
        message = "Assesment"


      }



      if (type === 4) {

        filt = selectsRec.filter((i) => i.profileFilledPercentage !== "100%")
        message = "Application"
      }

      if (type === 5 || type === 6) {

        filt = selectsRec.filter((i) => i.profileFilledPercentage === "100%")
        message = "Application Not"

      }

    } else if (type === 2) {
      filt = selectsRec.filter((i) => i.quizScore === 'N/A')
      message = "Quiz"

    } else if (type === 3) {

      filt = selectsRec
    }

    setMailRecords(prev => ({
      ...prev,
      all: all,
      sendTo: filt,
      notInrsted: all - selectsRec.length,
      type: message
    }))
  }


  const handleSendEmail = (event, reson = 0) => {
    console.log(selectsRec);
    console.log("HTML Content:", emailContent);
    const name = event.target.name;
    // setIsSending(true);
    let payload;

    if (mailKey === 1 || mailKey == 4 || mailKey === 5 || mailKey == 6) {

      payload = {
        htmlContent: emailContent,
        ccEmails: ccEmails,
        frequency: Number(freq),
        stopbyAttempts: Number(stop),
        subject: subject,
        whatsAppMessage: whatsApp,
        fromEmail: from,
        stopbyDate: stopby,
        round: mailKey,
      };

      if (mailKey === 1) {
        payload.assmentUsers = mailRecords?.sendTo
          .map((x) => ({
            userId: x.userId,
            codeId: x.id,
            email: x.emailId,
            phone: x.phoneNumber,
          }))
      }

      if (mailKey === 4) {
        payload.assmentUsers = mailRecords?.sendTo
          .map((x) => ({
            userId: x.userId,
            codeId: x.id,
            email: x.emailId,
            phone: x.phoneNumber,
          }))
      }

      if (mailKey === 5 || mailKey === 6) {
        payload.assmentUsers = mailRecords?.sendTo
          .map((x) => ({
            userId: x.userId,
            codeId: x.id,
            email: x.emailId,
            phone: x.phoneNumber,
          }))
      }

    } else if (mailKey === 2) {

      payload = {
        htmlContent: emailContent,
        ccEmails: ccEmails,
        frequency: Number(freq),
        stopbyAttempts: Number(stop),
        subject: subject,
        whatsAppMessage: whatsAppRoundTwo,
        fromEmail: from,
        stopbyDate: stopby,
        round: 2,
        assmentUsers: mailRecords?.sendTo
          .map((x) => ({
            userId: x.userId,
            codeId: x.id,
            email: x.emailId,
            phone: x.phoneNumber,
          })),
      };
    } else if (mailKey === 0) {

      payload = {
        htmlContent: emailContent,
        ccEmails: ccEmails,
        subject: subject,
        fromEmail: from,
        // frequency: Number(freq),
        // stopbyAttempts: Number(stop),
        // stopbyDate: stopby,
        assmentUsers: selectsRec.map((x) => ({
          userId: x.userId,
          codeId: x.id,
          email: x.emailId,
          phone: x.phoneNumber,
        })),
      };
    } else if (mailKey === 3) {
      payload = {
        htmlContent: emailContent,
        ccEmails: ccEmails,
        subject: subject,
        fromEmail: from,
        whatsAppMessage: whatsAppRej,
        round: 3,
        assmentUsers: selectsRec.map((x) => ({
          userId: x.userId,
          codeId: x.id,
          email: x.emailId,
          phone: x.phoneNumber,
        })),
      }
    } else if (mailKey === 7) {
      payload = {
        htmlContent: emailContent,
        ccEmails: ccEmails,
        subject: subject,
        fromEmail: from,
        whatsAppMessage: whatsAppRej,
        round: 7,
        assmentUsers: selectsRec.map((x) => ({
          userId: x.userId,
          codeId: x.id,
          email: x.emailId,
          phone: x.phoneNumber,
        })),
      }
    }
    console.log("Sending Payload:", JSON.stringify(payload));
    console.log(ccEmails);

    handleHideMail();
    handleHideApp();
    handleHideRound();

    if (selectsRec.length > 0 && emailContent) {
      PostCallWithErrorResponse(ApiConfig.SEND_ASSESSMENT_REMINDER, payload)
        .then((res) => {
          console.log(res);

          if (res.json.status) {
            toastMsg("success", res.json.statusMessage);
            // handleHideMail();
            // handleHideApp();
            // handleHideRound();

            // setEmailContent("");

            setFreq(null);
            setStop(null);
            setStopby(null);
            handleHideMailTest();
            handleHideReject();
            setSelectsRec([]);
            setSelects([]);
            // getList(code);
            setWhatsApp(false);
            setWhatsAppRej(false);
            setWhatsAppRoundTwo(false);
            // setSelectsRec([]);
          } else {
            toastMsg("error", res.json.statusMessage);
          }
        })
        .catch((err) => console.log(err));
      // .finally(() => setIsSending(false));
    } else if (selectsRec.length === 0) {
      toastMsg("error", "please select the Respondents first");
    } else {
      toastMsg("error", "please enter the message");
    }
  };
  const [selectedOption, setSelectedOption] = useState("1");

  const handleSendOption = () => {
    console.log("Selected:", selectedOption);
    // Do something with the selected option
  };

  const [toEmails, setToEmails] = useState([]);
  const [inputValueTest, setInputValueTest] = useState([]);
  const handleKeyDownTest = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const email = inputValueTest.trim();
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (email && isValidEmail && !toEmails.includes(email)) {
        setToEmails((prevEmails) => [...prevEmails, email]);
      } else {
        toastMsg("error", "Please enter valid email Id");
      }
      setInputValueTest("");
    }
  };
  const removeEmailTest = (emailToRemove) => {
    setToEmails(toEmails.filter((x) => x != emailToRemove));
  };

  const handleSendEmailTest = (e) => {
    if (toEmails.length > 0) {
      const { name } = e.target;
      const payload = {
        fromEmail: from,
        htmlContent: emailContent,
        emails: toEmails,
        subject: subject,
      };
      handleHideMailTest();
      PostCallWithErrorResponse(ApiConfig.SEND_ASSESSMENT_REMINDER, payload)
        .then((res) => {
          console.log(res);
          if (res.json.status) {
            toastMsg("success", res.json.statusMessage);
            setToEmails([]);
            // handleHideMail();
            // handleHideApp();
            // handleHideRound();

            // setEmailContent("");

            // handleHideMailTest();
            // setSelectsRec([]);
          } else {
            toastMsg("error", res.json.statusMessage);
          }
        })
        .catch((err) => console.log(err));
    } else {
      toastMsg("error", "Kindly add receiver email Id and press enter key");
    }
  };
  console.log(selectsRec, "wanted");

  const handleSendWhatsapp = () => {
    const payload = {
      round: selectedOption,
    };

    payload.whatsAppNumbers = selectsRec
      ?.filter((i) =>
        selectedOption == "1"
          ? i?.percentage != "100%"
          : i?.round2 !== "Completed" && i?.round2 !== "Sent"
      )
      ?.map((i) => ({
        userId: i.userId,
        codeId: i.id,

        phone: i.phoneNumber,
      }));

    PostCallWithErrorResponse(ApiConfig.SEND_ASSESSMENT_REMINDER, payload)
      .then((res) => {
        console.log(res);
        if (res.json.status) {
          toastMsg("success", res.json.statusMessage);
        } else {
          toastMsg("error", res.json.statusMessage);
        }
      })
      .catch((err) => console.log(err));
    // } else {
    //   toastMsg("error", "Kindly add receiver email Id and press enter key");
    // }
  };
  const handleSendTestMsg = (event) => {
    const { name } = event.target;

    if (phoneMsg.length === 10 || phoneMsg.length === 12) {
      const payload = {
        // fromEmail: from,
        htmlContent: emailContent,
        phoneNumber: phoneMsg + "",
        whatsAppMessage: true,
        code: code,
        round: name === "whatsappapplicationone" ? 1 : 2,
      };
      handleHideTestMsg();
      PostCallWithErrorResponse(ApiConfig.SEND_ASSESSMENT_REMINDER, payload)
        .then((res) => {
          console.log(res);
          if (res.json.status) {
            toastMsg("success", "message sent successfully");
            setPhoneMsg("");
            handleHideTestMsg();
            handleHideTestMsgRoundtwo();
            // handleHideMail();
            // handleHideApp();
            // handleHideRound();

            // setEmailContent("");

            // handleHideMailTest();
            // setSelectsRec([]);
          } else {
            toastMsg("error", "something went wrong");
          }
        })
        .catch((err) => console.log(err));
    } else {
      toastMsg("error", "Kindly add receiver phone number");
    }
  };
  const [showSelectUser, setShowSelectUser] = useState(false);
  const handleShowSelectUser = () => {
    setShowSelectUser(true);
  };
  const handleHideSelectUser = () => {
    setShowSelectUser(false);
  };

  const [showInProg, setShowInProg] = useState(false);
  const handleShowInProg = () => {
    setShowInProg(true);
  };
  const handleHideInProg = () => {
    setShowInProg(false);
  };

  const toggleSwitch = () => {
    setIsActive(!isActive);
    getList(code, !isActive)
  };


  const updateQuizScore = () => {

    PostCallWithErrorResponse(ApiConfig.UPDATE_QUIZ_SCORE + code).then((res) => {

      if (res?.json?.succeded) {
        toastMsg('success', res?.json?.response)
        getList(code, isActive)
      }

    })

  }

  const generateBulkSummaryReport = () => {

    if (isGeneratingReport) return

    if (!selectsRec?.length) {

      toastMsg('error', 'Please Select Candiate')

      return

    }

    setSummaryMsg(true)

    setIsGenerRatingReport(true)
    let payload = {
      "userIds": selectsRec?.map((candidate) => candidate?.userId),
      "code": code,
      Admin: adminData?.email
    }

    PostCallWithErrorResponse(ApiConfig?.BULK_SUMMARY_REPORT, payload).then((res) => {

      // if (res?.json?.succeded) {
      //   toastMsg('success', "Summary Report Generated Successfully !")
      //   getList(code)
      // } else {
      //   toastMsg('error', "Something went wrong try again leter")
      // }

      setIsGenerRatingReport(false)

    })

  }



  return (
    <div className="candListBox">
      <div className="candListHdr">
        {code?.length > 0 ? (
          <div className="canLisSearchArea ">
            {/* <div> */}
            {/* <h5>{code}</h5> */}
            {/* <img src={SearchIcon} className="boxIcon" alt="Logo" />
            <input
              type="text"
              disabled={isDiasableSearch}
              className="searchInput"
              placeholder="Search"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                getList(e.target.value);
              }}
              // readOnly
            /> */}
            {/* </div> */}
            {/* <-------------Jb----------> */}
            {/* <div className="d-flex ">
              <div
                className="d-flex  flex-column"
                style={{ gap: companyDtls?.company ? "30px" : "0px" }}
              >
                {!companyDtls?.company && (
                  <p className="mb-0">{companyDtls?.designation}</p>
                )}
                <h5 style={{ height: "0px" }}>{companyDtls?.company || " "}</h5>

                <p>{companyDtls?.position}</p>
              </div>
              <div className="ms-4">
                {companyDtls?.company && (
                  <p className="mb-0">{companyDtls?.designation}</p>
                )}
                <p
                  style={{ height: companyDtls?.company ? "0px" : "17px" }}
                ></p>

                <p className="mt-2">{sel > 0 ? sel : accessCodeList.length}</p>
              </div>
            </div> */}
            <div className="col-md-2 col-sm-12">
              <h5 style={{ minWidth: '500px' }}>{position || " "}</h5>
              <div className="d-flex col-md-3" style={{ width: "100%" }}>
                <div
                  className="d-flex  flex-column"
                  // style={{ gap: companyDtls?.company ? "30px" : "0px" }}
                  style={{ position: "relative", bottom: "12px" }}
                >
                  {/* {!companyDtls?.company && (
                    <p className="mb-0">{companyDtls?.designation}</p>
                  )} */}
                  {/* <h5>{companyDtls?.company || " "}</h5> */}
                  <h5></h5>
                  {
                    (permissions?.isView || permissions?.isEdit) &&

                    <p style={{ marginBottom: "0px", fontFamily: 'Inter-Regular' }}>{type}
                      <span className="ml-1" style={{ fontFamily: 'Inter-Regular', color: '#4375f4', fontSize: '13px', marginLeft: '10px', cursor: 'pointer' }}

                        onClick={() => navigate(`/addEditGroup/${code}/?isAccessCode=true`)}

                      >Edit</span>

                      {/* <FontAwesomeIcon icon={faPenToSquare} style={{ color: '#333', fontSize: '15px', marginLeft: "10px", cursor: "pointer" }} /> */}
                    </p>
                  }








                </div>
                <div className="ms-4">
                  {type && <p className="mb-0"></p>}
                  <p
                    style={{
                      // height: companyDtls?.company ? "0px" : "17px",
                      marginTop: "-18px",
                    }}
                  ></p>

                  {/* <p className="mt-2">
                    0/{sel > 0 ? sel : accessCodeList.length}
                  </p> */}
                </div>
              </div>
            </div>
            {/* ------------------------------- */}

            {/* <h5>{`${companyDtls?.position}${
              companyDtls?.designation?.length > 0 ? ", " : ""
            }${companyDtls?.designation}${
              companyDtls?.company?.length > 0 ? ", " : ""
            } ${companyDtls?.company}  `}</h5> */}

            {/* <------------Head div----------------> */}
            <div
              className="col-md-10 col-sm-12"
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
              }}
            >
              {/* Centered Search Box */}

              <div
                className={`d-flex flex-row justify-content-center ${type === "Job Application" && 'align-items-center'}`}
                style={{ flex: 1, marginLeft: type === "Job Application" ? "0px" : '-200px' }}
              >

                <div>
                  {
                    type === "Job Application" && <>
                      <div className="d-flex justify-content-between">
                        <span className="ml-2"
                          onClick={() => setShowAdvanceFilter(true)}
                          style={{ fontFamily: 'Inter-Regular', color: '#4375f4', fontSize: '13px', marginLeft: '5px', cursor: 'pointer' }}
                        >
                          Advanced Filter
                        </span>
                        <span className="ml-2"
                          onClick={() => {
                            setFilteredInfo({})
                            setIsClearFiltres(true)
                            setSelectedFilter('')
                            setSearch('')
                            setFilteredData([])
                          }}
                          style={{ fontFamily: 'Inter-Regular', color: '#4375f4', fontSize: '13px', cursor: 'pointer' }}
                        >
                          Clear All
                        </span>
                      </div>
                      {/* <div style={{ width: '400px' }}>
                        <CustomSelect
                          options={filterList}
                          value={selectedFilter}
                          valKey="value"
                          labelKey="label"
                          size="small"
                          handleChange={(e, data) => {
                            setIsFilter(true)

                            if (e) {

                              setAccessCoeList(filterApplicant(allData, JSON.parse(data?.details?.details?.filterJson) || {}))
                            } else {
                              setAccessCoeList(allData)
                            }


                            setSelectedFilter(e)
                          }}
                        />
                      </div> */}
                    </>
                  }

                  <div className="canLisIconBox ms-1 activeInAvtie d-flex align-items-center"

                  >

                    <input
                      type="text"
                      className="border-0 search-input"
                      style={{ width: "92%" }}
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        filterDataByAll(e.target.value);
                      }}
                    />
                    <img src={searchicon} className="boxIcon" alt="Logo" />
                  </div>

                </div>
                <p className="mb-0 ms-2"

                  style={{ marginTop: type === "Job Application" ? '23px' : '7px' }}
                >

                  {/* {search?.length > 0 || isFilter ? accessCodeList?.length : sel > 0 ? sel : allData.length} */}
                  {filteredData?.length ? filteredData?.length : accessCodeList?.length}/{allData.length}
                </p>
              </div>



              {/* Right Side Action Buttons */}
              <div
                style={{
                  width: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginLeft: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: "20px",
                    width: '100%'
                  }}
                >
                  {/* Icons */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    {
                      type === 'Job Application' && <>
                        <Tooltip
                          title="Generate Summary Report"
                        >
                          <img
                            src={summaryIco}
                            style={{ cursor: "pointer", paddingTop: "2px" }}
                            width={28}
                            height={28}
                            alt="Question Icon"
                            onClick={generateBulkSummaryReport}

                          />
                        </Tooltip>
                        {/* <Tooltip
                          title="Generate Detailed Personality Report"
                        >
                          <img
                            src={personalityreporticon}
                            style={{ cursor: "pointer", paddingTop: "2px" }}
                            width={30}
                            height={30}
                            alt="Question Icon"
                          // onClick={generateBulkSummaryReport}

                          />
                        </Tooltip> */}
                      </>
                    }
                    {
                      (adminData?.admin == "Admin" && quizSource == 'Custom Quiz') && <Tooltip
                        title="Update Quiz Score"
                      >
                        <img
                          src={refresh}
                          width={28}
                          height={28}
                          style={{ cursor: "pointer", marginTop: '1px' }}
                          onClick={updateQuizScore}
                        />
                      </Tooltip>
                    }
                    {
                      quizSource == 'Custom Quiz' &&
                      <div style={{ position: "relative", display: "inline-block" }}>
                        <Tooltip
                          title="Quiz Mail Matching"
                        >
                          <img
                            src={questionicon}
                            style={{ cursor: "pointer", paddingTop: "2px" }}
                            width={30}
                            height={27}
                            alt="Question Icon"
                            role="button"
                            id="dropdownMenuButton"
                            aria-expanded="false"
                            onClick={() => setIsDetailedPersonality(true)}
                          />
                        </Tooltip>
                        {
                          counyMatch != 0 &&

                          <Badge
                            pill
                            style={{
                              position: "absolute",
                              top: "-12px",
                              right: "-7px",
                              fontSize: "13px",
                              backgroundColor: "transparent", // remove bg color
                              color: "red",                  // text color (set as you like)
                              border: "none",                  // remove border if any
                              minWidth: "18px",
                              height: "18px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "none",               // remove subtle Bootstrap shadow
                              "--bs-bg-opacity": 0,            // make sure Bootstrap vars don't override
                            }}
                          >
                            {counyMatch}
                          </Badge>
                        }

                      </div>
                    }

                    {/* <img
                      src={questionicon}
                      style={{ cursor: "pointer", paddingTop: "2px" }}
                      width={30}
                      height={27}
                      alt="Question Icon"
                      role="button"
                      id="dropdownMenuButton"
                      // data-bs-toggle={type === "Job Application" ? "dropdown" : ""}
                      aria-expanded="false"
                      onClick={() => {
                        setIsDetailedPersonality(true)
                      }}
                    /> */}
                    <Tooltip
                      title="Send Emails"
                    >
                      <img
                        src={mail1}
                        style={{ cursor: "pointer" }}
                        width={29}
                        height={29}
                        alt="Mail Icon"
                        role="button"
                        id="dropdownMenuButton"
                        data-bs-toggle={type === "Job Application" ? "dropdown" : ""}
                        aria-expanded="false"
                        onClick={() => {
                          if (type !== "Job Application") {
                            handleShowApp(0);
                          }
                        }}
                      />
                    </Tooltip>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      style={{
                        minWidth: "230px",
                        padding: "0",
                        marginTop: "10px",
                        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        overflow: "hidden",
                      }}
                    >
                      {mailTypes.map((option, index) => (
                        <li
                          key={index}
                          onClick={() => {
                            handleShowApp(option?.key);
                          }}
                        >
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderBottom: index !== 5 ? "1px solid #eee" : "none",
                              color: "#333",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.backgroundColor = "#f1f1f1")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.backgroundColor = "#fff")
                            }
                          >
                            {option?.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <Tooltip
                      title="Delete Selected Candidate"
                    >
                      <img
                        src={del1}
                        width={24}
                        height={24}
                        style={{ cursor: "pointer", marginTop: '1px' }}
                        onClick={deleteBulkUser}
                      />
                    </Tooltip>
                    <Tooltip
                      title="Download Candidate Personality Test Response"
                    >
                      <img
                        src={file2}
                        width={25}
                        height={25}
                        style={{ cursor: "pointer", marginTop: '1px' }}
                        onClick={downLoadList}
                      />
                    </Tooltip>
                    <Tooltip
                      title="Download Candidate Response"
                    >
                      <img
                        src={exp1}
                        width={25}
                        height={25}
                        style={{ cursor: "pointer", marginTop: '1px' }}
                        onClick={() => ResponseApi(codeId)}
                      />
                    </Tooltip>
                  </div>

                  {/* Switch and Select */}
                  {
                    type === 'Job Application' &&

                    <div>
                      <div className="switch-container">
                        <span className="switch-text" style={{ fontSize: "13px", fontFamily: "Inter-Regular" }}>
                          Show Inactive / Not Interested
                        </span>
                        <label style={{ marginBottom: "1px", marginLeft: '5px' }} className="switch">
                          <input
                            type="checkbox"
                            checked={!isActive}
                            onChange={toggleSwitch}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                      <MultipleSelectCheckmarks
                        options={statusOptionss}
                        selectedTags={selectedTags}
                        setSelectedTags={setSelectedTags} seletedRecord={selectsRec} code={code}
                        getList={getList}
                        setSelectsRec={setSelectsRec}
                        getTags={getTags}
                      />

                      {/* <select
                        className="form-select"
                        aria-label="Default select example"
                        style={{ width: "229px", height: "33px", fontSize: "12px" }}
                        value={status}
                        onChange={(e) => updateStatus(e.target.value)}
                      >
                        <option value={""} disabled selected>Set Tags</option>
                        {statusOptionss.map((option, index) => (
                          <option
                            key={index}
                            value={option === "Tags" ? "" : option}
                            selected={option === "Tags"}

                          >
                            <input type="checkbox" /> {option}
                          </option>
                        ))}
                      </select> */}
                    </div>
                  }
                </div>
              </div>
            </div>


            {/* <div className="d-flex ms-auto justify-content-end">
              <div className="d-flex ">
                {type === "Job Application" && (
                  <div
                    className="d-flex flex-column align-items-center me-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleShowApp("application")}
                  >
                    <img
                      src={one}
                      alt="II"
                      className="img-fluid"
                      style={{ width: "35px", height: "auto" }}
                    />
                    <p className="mb-0" style={{ fontSize: "10px" }}>
                      Application
                    </p>
                  </div>
                )}

                {type === "Job Application" && (
                  <div
                    className="d-flex flex-column align-items-center me-3"
                    onClick={() => handleShowRound("round2")}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={two}
                      alt="II"
                      style={{ width: "35px", height: "auto" }}
                    />
                    <p className="mb-0" style={{ fontSize: "10px" }}>
                      Round 2
                    </p>
                  </div>
                )}

                {type === "Job Application" && (
                  <div
                    className="d-flex flex-column align-items-center me-3"
                    style={{ cursor: "pointer" }}
                    name="select"
                    onClick={handleShowSelectUser}
                  >
                    <img
                      src={check}
                      alt="II"
                      style={{ width: "34px", height: "auto" }}
                    />
                    <p className="mb-0" style={{ fontSize: "10px" }}>
                      Select
                    </p>
                  </div>
                )}

                <div
                  className="d-flex flex-column align-items-center me-2"
                  onClick={() => handleShowMail("mail")}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={mail}
                    alt="II"
                    style={{ width: "35px", height: "auto" }}
                  />
                  <p className="mb-0" style={{ fontSize: "10px" }}>
                    Mail
                  </p>
                </div>
                <div
                  className="d-flex flex-column align-items-center me-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowWhatsapp(true)}
                >
                  <img
                    src={whatsappss}
                    alt="II"
                    style={{ width: "35px", height: "auto" }}
                  />
                  <p className="mb-0" style={{ fontSize: "10px" }}>
                    WhatsApp
                  </p>
                </div>

                {type === "Job Application" && (
                  <div
                    className="d-flex flex-column align-items-center me-1"
                    style={{ cursor: "pointer" }}
                    onClick={handleShowInProg}
                  >
                    <img
                      src={inProg}
                      alt="II"
                      style={{ width: "33px", height: "36px" }}
                    />
                    <p className="mb-0" style={{ fontSize: "10px" }}>
                      In-progress
                    </p>
                  </div>
                )}

                {type === "Job Application" && (
                  <div
                    className="d-flex flex-column align-items-center me-3"
                    name="reject"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleShowReject("reject")}
                  >
                    <img
                      src={crosscircle}
                      alt="II"
                      style={{ width: "35px", height: "auto" }}
                    />
                    <p className="mb-0" style={{ fontSize: "10px" }}>
                      Reject
                    </p>
                  </div>
                )}
                <div
                  className="d-flex flex-column align-items-center me-3"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={downl}
                    alt="II"
                    style={{ width: "32px", height: "auto" }}
                    onClick={downLoadList}
                  />
                  <p className="mb-0 mt-1" style={{ fontSize: "10px" }}>
                    Download
                  </p>
                </div>

                <div
                  className="d-flex flex-column align-items-center me-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => ResponseApi(codeId)}
                >
                  <img
                    src={downl}
                    alt="II"
                    style={{ width: "32px", height: "auto" }}
                  />
                  <p className="mb-0 mt-1" style={{ fontSize: "10px" }}>
                    Responses
                  </p>
                </div>
              </div>
            </div> */}

            {/* <-------------- New Head ------------------> */}

            {/* ----------------------------------------------------------------------- */}
          </div>
        ) : (
          <h6 className="text-secondary">
            No data available for display, process is to select Access Code to
            see responded data
          </h6>
        )}
      </div>

      {code?.length > 0 && (
        <div>
          {type === "Job Application" ? (
            <Table
              size="large"
              columns={columns}
              dataSource={accessCodeList}
              onChange={handleChange}
              pagination={false}
              className="grouplisttable"

            // scroll={{ x: 'max-content', y: 155 * 3 }}

            // sticky={{ offsetHeader: 0 }}
            // rowSelection={{
            //   type: "checkbox",
            //   onSelect: (record) => {
            //     console.log(record.userId);
            //   }
            // }}
            />
          ) : (
            <Table
              size="large"
              columns={column1}
              dataSource={accessCodeList}
              onChange={handleChange}
              pagination={false}
              className="grouplisttable"

            // sticky={{ offsetHeader: 0 }}
            // rowSelection={true}
            />
          )}
        </div>
      )}
      <Modal
        show={showmodal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal position-relative"
        size="lg"
      >
        <div
          className="position-absolute btn btn-close"
          style={{ top: "25px", right: "20px", zIndex: "99" }}
          onClick={() => setShowmodal(false)}
        ></div>
        <Modal.Body>
          <div className="row">
            {onePer.map((personality, index) => (
              <div key={index} className="col border rounded-3 mx-2">
                <div className="row">
                  <div className="col-12" style={{ background: "#FFE6D5" }}>
                    <div className="row justify-content-between align-items-center mt-5">
                      <div className="col-6">
                        <img src={personality.img_card} alt="card-image"></img>
                      </div>
                      <div className="col-6">
                        <div className="row flex-column align-items-center">
                          <div className="col-6 d-flex justify-content-center ">
                            <img
                              width={50}
                              src={personality.img_letter}
                              alt="card-image-letter"
                            />
                          </div>
                          <div className="col-12">
                            <p
                              className="text-center"
                              style={{
                                fontSize: "48px",
                                fontWeight: "600",
                                lineHeight: "60px",
                              }}
                            >
                              {personality.personality}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row justify-content-end">
                      <div className="col-12 my-4 d-flex justify-content-start">
                        {/* <img
                          className="me-2"
                          width={40}
                          src={personality.img_letter}
                          alt="personality-letter"
                        /> */}

                        {/* <h2
                          className="my-auto"
                          style={{ fontSize: "25px", fontWeight: "600" }}
                        >
                          {personality.personality}
                        </h2> */}
                      </div>
                      <div className="col-10 mx-auto">
                        <p style={{ fontSize: "12px" }}>{personality.text}</p>
                        <hr />
                      </div>
                      <div className="col-10 mx-auto mb-5">
                        <div className="row">
                          <div className="col-2">
                            <p style={{ fontSize: "12px" }} className="">
                              <strong>Strengths</strong>
                            </p>
                          </div>
                          <div className="col">
                            <p style={{ fontSize: "12px" }}>
                              {personality.strengths}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-2">
                            <p style={{ fontSize: "12px" }} className="">
                              <strong>Uniqueness</strong>
                            </p>
                          </div>
                          <div className="col">
                            <p style={{ fontSize: "12px" }}>
                              {personality.uniqueness}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-2">
                            <p
                              style={{ fontSize: "12px" }}
                              className="text-nowrap"
                            >
                              <strong>Value to Org.</strong>
                            </p>
                          </div>
                          <div className="col">
                            <p style={{ fontSize: "12px" }}>
                              {personality.valtoorg}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-2">
                            <p
                              style={{ fontSize: "12px" }}
                              className="text-nowrap"
                            >
                              <strong>Challanges</strong>
                            </p>
                          </div>
                          <div className="col">
                            <p style={{ fontSize: "12px" }}>
                              {personality.challenges}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-2">
                            <p style={{ fontSize: "12px" }} className="">
                              <strong>Motivations</strong>
                            </p>
                          </div>
                          <div className="col">
                            <p style={{ fontSize: "12px" }}>
                              {personality.motivations}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        {/* <Modal.Header closeButton className="custom-close-btn">
        </Modal.Header>
      <Modal.Body>
        <div className="row">

        <div className="col p-3 border rounded-3">
                            <div className="">
                                 <div className="d-flex px-3">
                                    <h5 style={{fontSize:"20px", fontWeight:"700", lineHeight:"30px"}} className="me-2">78%</h5>
                                    <p>----------------------</p>
                                </div>
                             <div className="d-flex align-items-center ms-2" style={{cursor:"pointer"}} onClick={handleShowPersonalityCard}>
                                <img className="me-2" width={40} src={mediatorLetter}/>
                                <h2 className="mb-0" style={{fontSize:"20px", fontWeight:"700"}}>Mediator</h2>
                             </div>
                            </div>
                </div>
        </div>
      </Modal.Body> */}
      </Modal>

      <Modal show={showApplication} onHide={handleHideApp} size="lg">
        <Modal.Header closeButton className="custom-close-btn">
          {/* <h6 className="mb-0 mt-1">{subject}</h6> */}
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              <div className="d-flex">
                <Form.Label className="me-2" style={{ width: "50px" }}>
                  To
                </Form.Label>
                <p>
                  {mailRecords?.sendTo?.length} / {mailRecords?.all} Selected
                </p>
              </div>
              <div className="d-flex">
                <Form.Label className="me-2" style={{ width: "50px" }}>
                  Excl
                </Form.Label>
                <p>
                  {mailRecords?.notInrsted} Not Interested,  {mailRecords?.all - mailRecords?.notInrsted - mailRecords?.sendTo.length} {mailRecords.type} Completed
                </p>
              </div>

              {/* <div>
                {
                  selectsRec?.filter(i => i?.c)?.map((i) => {
                    return
                  })
                }
              </div> */}
              <div className="d-flex align-items-center mb-3">
                <Form.Label className="me-2">Subject</Form.Label>
                <Form.Control
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              {from && (
                <div className="d-flex mt-1">
                  <Form.Label className="me-2" style={{ width: "50px" }}>
                    From
                  </Form.Label>
                  <p>{from}</p>
                </div>
              )}
              {/* <div className="d-flex">
                <Form.Label className="me-2" style={{ width: "50px" }}>
                  To
                </Form.Label>
                <p>
                  All Incomplete Applications
                </p>
              </div> */}
            </Form.Group>
            <Form.Group>
              <div className="d-flex mb-3 ">
                <Form.Label className="me-2 my-auto" style={{ width: "50px" }}>
                  Cc
                </Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {ccEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmail(x)}
                    >
                      {x}
                    </Badge>
                  ))}
                  <Form.Control
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Add email and press enter"
                    onKeyDown={handleKeyDown}
                    className="border-0"
                  // style={{
                  //   border: "none",
                  //   display: "inline-block",
                  //   width: "auto",
                  // }}
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>
            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "178px" }}
                theme="snow"
                value={emailContent}
                onChange={(content) => {

                  setEmailContent(content);

                }}
                modules={modules}
                formats={formats}
                // bounds={"#root"}
                placeholder={placeholder}
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: "50px" }}>
            {/* <div className="col-3">
              <Form.Group>
                <Form.Label>Reminder Frequency</Form.Label>
                <Form.Select
                  name="freq reminder"
                  id="freq reminder"
                  value={freq}
                  onChange={(e) => setFreq(e.target.value)}
                >
                  <option selected disabled value="">
                    Select frequency
                  </option>
                  <option value={1}>Every Day 1</option>
                  <option value={2}>Every Day 2</option>
                  <option value={3}>Every Day 3</option>
                  <option value={4}>Every Day 4</option>
                  <option value={5}>Every Day 5</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-3">
              <Form.Group>
                <Form.Label>Stop After</Form.Label>
                <Form.Select
                  name="stop after"
                  id="stop after"
                  value={stop}
                  onChange={(e) => setStop(e.target.value)}
                >
                  <option selected disabled value="">
                    Stop after
                  </option>
                  <option value={1}>1 Attempt</option>
                  <option value={2}>2 Attempt</option>
                  <option value={3}>3 Attempt</option>
                  <option value={4}>4 Attempt</option>
                  <option value={5}>5 Attempt</option>
                  <option value={6}>6 Attempt</option>
                  <option value={7}>7 Attempt</option>
                  <option value={0}>Until job application closed</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-1">
              <p>(or)</p>
            </div>

            <div className="col-3">
              <Form.Group>
                <Form.Label>Stop By</Form.Label>
                <Form.Control
                  name="stopby"
                  id="stopby"
                  value={stopby}
                  onChange={(e) => setStopby(e.target.value)}
                  type="date"
                ></Form.Control>
              </Form.Group>
            </div> */}

            {/* <div className="d-flex justify-content-end col-12">
              <button
                className="border-0 text-white px-3 mb-1 py-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "12px" }}
                name="application send"
                onClick={handleSendEmail}
              // disabled={isSending}
              >
                Send
          
              </button>
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "12px" }}
                name="application send test"
                onClick={handleShowMailTest}
              >
                Test Email
              </button>
             
            </div> */}

          </div>
          <div className="row  " style={{ marginTop: '-10px', marginRight: '-40px' }}>
            <div className="col-md-8 d-flex mt-1 ml-1 gap-2">
              <span style={{ fontFamily: 'Inter-Regular' }}> Use last sent template</span>

              <Form.Check
                checked={isDefaultEmailContent}
                type="switch"
                id={"custom-switch"}

                className="custom-switch"
                onChange={e => {
                  setIsDefaultEmailContent(e.target.checked)
                  htmlContentData(emailContentType, e.target.checked)
                }}
              // disabled={isDefaultEmailContent}
              />
              <span style={{ marginLeft: '-8px', fontFamily: 'Inter-Regular' }}>Fetch default template</span>
            </div>
            <div className="col-4 d-flex justify-content-end">
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "12px", width: '150px' }}
                name="application send test"
                onClick={handleShowMailTest}
              >
                Test Email
              </button>
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100"
                name="only email send"
                style={{ fontSize: '12px' }}
                onClick={handleSendEmail}
              >
                Send
              </button>
            </div>
          </div>
        </Modal.Body >
      </Modal >

      <Modal show={showRound2} onHide={handleHideRound} size="lg">
        <Modal.Header closeButton className="custom-close-btn">
          {/* <h6 className="mb-0 mt-1">{subject}</h6> */}
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              <div className="d-flex align-items-center mb-3">
                <Form.Label className="me-2">Subject</Form.Label>
                <Form.Control
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              {from && (
                <div className="d-flex mt-1">
                  <Form.Label className="me-1" style={{ width: "50px" }}>
                    From
                  </Form.Label>
                  <p>{from}</p>
                </div>
              )}
              <div className="d-flex">
                <Form.Label className="me-2" style={{ width: "50px" }}>
                  To
                </Form.Label>

                {/* {!hoverTrue && ( */}
                <div className="d-flex flex-column">
                  <p className="mb-0">
                    <span
                    // onClick={() => setHoverTrue(true)}
                    // style={{ cursor: "pointer" }}
                    >
                      {/* {selects.length} */}
                    </span>{" "}
                    {/* Respondents with completed applications who have not been
                    invited to Round 2 Yet. Incomplete Applications */}
                    Respondents with completed applications whom we want to get
                    Round 2 Completed.
                    {/* {selectsRec.filter(x => x.round2 !== "Completed" && x.round2 !== "Sent").length} */}
                  </p>
                  <small>
                    does not include respondents who have already been invited
                    to Round 2
                  </small>
                </div>
                {/* )} */}
                {/* {hoverTrue && (
  <div className="row">
    {selectsRec.map((x, index) => (
      <div
        key={x.userId}
        className={`${selectsRec.length < 4 ? "col-12" : "col-4"} rounded-3`}
        style={{
          fontSize: "14px",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        <p
          style={{
            backgroundColor: "lightgrey",
            border: "1px solid white",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            padding: "8px",
            // textAlign: "center",
          }}
          className="p-1 rounded-2"
        >
          {x.emailId}
        </p>
      </div>
    ))}
  </div>
)} */}

                {/* <div className="d-flex flex-column">
                  <p className="mb-0">
                    {selects.length} Respondents with completed applications who
                    have not been invited to Round 2 Yet.
                  </p>
                  <p>
                    <small>
                      does not include respondents who have already been invited
                      to Round 2
                    </small>
                  </p>
                </div> */}
              </div>
            </Form.Group>
            <Form.Group>
              <div className="d-flex my-3">
                <Form.Label className="me-2 my-auto" style={{ width: "50px" }}>
                  Cc
                </Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {ccEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmail(x)}
                    >
                      {x}
                    </Badge>
                  ))}
                  <Form.Control
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Add email and press enter"
                    onKeyDown={handleKeyDown}
                    className="border-0"
                  // style={{
                  //   border: "none",
                  //   display: "inline-block",
                  //   width: "auto",
                  // }}
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>

            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "195px" }}
                theme="snow"
                value={emailContent}
                onChange={setEmailContent}
                modules={modules}
                formats={formats}
                // bounds={"#root"}
                placeholder={placeholder}
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: "60px" }}>
            <div className="col-3">
              <Form.Group>
                <Form.Label>Reminder Frequency</Form.Label>
                <Form.Select
                  name="freq reminder"
                  id="freq reminder"
                  value={freq}
                  onChange={(e) => setFreq(e.target.value)}
                >
                  <option selected disabled value="">
                    Select frequency
                  </option>
                  <option value={1}>Every Day 1</option>
                  <option value={2}>Every Day 2</option>
                  <option value={3}>Every Day 3</option>
                  <option value={4}>Every Day 4</option>
                  <option value={5}>Every Day 5</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-3">
              <Form.Group>
                <Form.Label>Stop After</Form.Label>
                <Form.Select
                  name="stop after"
                  id="stop after"
                  value={stop}
                  onChange={(e) => setStop(e.target.value)}
                >
                  <option selected disabled value="">
                    Stop after
                  </option>
                  <option value={1}>1 Attempt</option>
                  <option value={2}>2 Attempt</option>
                  <option value={3}>3 Attempt</option>
                  <option value={4}>4 Attempt</option>
                  <option value={5}>5 Attempt</option>
                  <option value={6}>6 Attempt</option>
                  <option value={7}>7 Attempt</option>
                  <option value={0}>Until job application closed</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-1">
              <p>(or)</p>
            </div>
            <div className="col-3">
              <Form.Group>
                <Form.Label>Stop By</Form.Label>
                <Form.Control
                  name="stopby"
                  id="stopby"
                  value={stopby}
                  onChange={(e) => setStopby(e.target.value)}
                  type="date"
                ></Form.Control>
              </Form.Group>
            </div>

            <div className="d-flex flex-column col-2">
              <button
                className="border-0 text-white px-3 py-1 mb-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "12px" }}
                name="round two"
                onClick={handleSendEmail}
              >
                Send
              </button>
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "12px" }}
                name="round2 send test"
                onClick={handleShowMailTest}
              >
                Test Email
              </button>
              {/* <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt mt-1 w-100"
                name="send whatsapp round two"
                onClick={handleShowTestMsgRoundtwo}
                style={{ fontSize: "12px" }}
              >
                Test Message
              </button> */}
            </div>
            {/* <div className="mt-3" style={{ marginLeft: "440px" }}>
              <input
                type="checkbox"
                id="whatsappRoundTwo"
                name="whatsappRoundTwo"
                className="me-2"
                checked={whatsAppRoundTwo}
                onChange={(e) => setWhatsAppRoundTwo((previous) => !previous)}
              />
              <label className="" for="whatsappRoundTwo">
                Send WhatsApp messages
              </label>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showMail} onHide={handleHideMail} size="lg">
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Application</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              <div className="d-flex align-items-center mb-3">
                <Form.Label className="me-2">Subject</Form.Label>
                <Form.Control
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              <div className="d-flex mt-1">
                <Form.Label style={{ width: "50px" }}>To</Form.Label>

                <p>
                  <span>{selects.length}</span> Respondent
                  {selects.length === 1 ? "" : "s"} selected
                </p>
              </div>
            </Form.Group>
            <Form.Group>
              <div className="d-flex mb-3">
                <Form.Label className="my-auto" style={{ width: "50px" }}>
                  Cc
                </Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {ccEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmail(x)}
                    >
                      {x}
                    </Badge>
                  ))}
                  <Form.Control
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Add email and press enter"
                    onKeyDown={handleKeyDown}
                    className="border-0"
                  // style={{
                  //   border: "none",
                  //   display: "inline-block",
                  //   width: "auto",
                  // }}
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>
            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "170px" }}
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                value={emailContent}
                onChange={setEmailContent}
              />
            </div>
          </div>
          <div className="row justify-content-end mt-4">
            <div className="col-2 d-flex justify-content-end">
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
                name="only email send"
                onClick={handleSendEmail}
              >
                Send
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showWhatsapp}
        onHide={() => setShowWhatsapp(false)}
        size="lg"
      >
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Select The Template</h6>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <div className="d-flex align-items-center gap-2 mt-2 mb-3">
              <i
                className="bi bi-people-fill"
                style={{ fontSize: "1.5rem", color: "#0d6efd" }}
              ></i>
              <h5 className="m-0">
                <span>{selects.length}</span> Respondent
                {selects.length === 1 ? "" : "s"} selected
              </h5>
            </div>

            <hr />

            {/* <Form> */}
            <Form.Group>
              <div className="d-flex flex-column align-items-start gap-3 mt-3">
                <Form.Check
                  type="radio"
                  label="Assessment Incomplete"
                  value="1"
                  name="option"
                  checked={selectedOption == "1"}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  defaultChecked
                />
                <Form.Check
                  type="radio"
                  label="Round 2 Invite"
                  value="2"
                  name="option"
                  checked={selectedOption == "2"}
                  onChange={(e) => setSelectedOption(e.target.value)}
                />
              </div>

              <div className="row justify-content-end mt-4">
                <div className="col-3 d-flex justify-content-end">
                  <button
                    className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100"
                    name="only email send"
                    onClick={() => {
                      handleSendWhatsapp();
                      setShowWhatsapp(false);
                    }}
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </Form.Group>
            {/* </Form> */}
          </Form.Group>
        </Modal.Body>
      </Modal>
      <Modal show={reject} onHide={handleHideReject} size="lg">
        <Modal.Header closeButton className="custom-close-btn">
          {/* <h6 className="mb-0 mt-1">{subject}</h6> */}
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              <div className="d-flex align-items-center mb-3">
                <Form.Label className="me-2">Subject</Form.Label>
                <Form.Control
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              {from && (
                <div className="d-flex mt-1">
                  <Form.Label className="me-1" style={{ width: "50px" }}>
                    From
                  </Form.Label>
                  <p>{from}</p>
                </div>
              )}
              <div className="d-flex">
                <Form.Label style={{ width: "50px" }}>To</Form.Label>

                <p>
                  <span>{selects.length}</span> Respondent
                  {selects.length === 1 ? "" : "s"} selected
                </p>
              </div>
            </Form.Group>
            <Form.Group>
              <div className="d-flex mb-3">
                <Form.Label className="my-auto" style={{ width: "50px" }}>
                  Cc
                </Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {ccEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmail(x)}
                    >
                      {x}
                    </Badge>
                  ))}
                  <Form.Control
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Add email and press enter"
                    onKeyDown={handleKeyDown}
                    className="border-0"
                  // style={{
                  //   border: "none",
                  //   display: "inline-block",
                  //   width: "auto",
                  // }}
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>
            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "170px" }}
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                value={emailContent}
                onChange={setEmailContent}
              />
            </div>
          </div>
          <div className="row justify-content-end mt-4">
            <div className="col-2 d-flex justify-content-end align-items-start">
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
                name="reject"
                onClick={handleSendEmail}
              >
                Send
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showInProg} onHide={handleHideInProg} size="md" centered>
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">In Progress</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
              {selectsRec?.length} candidate
              {selectsRec?.length === 1 ? "" : "s"} will be moved to In progress
              status , kindly confirm
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
            onClick={handleHideInProg}
          >
            Cancel
          </button>
          <button
            className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
            onClick={() => handleSelectRejectStatus("in-progress")}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSelectUser}
        onHide={handleHideSelectUser}
        size="md"
        centered
      >
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Select User</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
              {selectsRec?.length} candidate
              {selectsRec?.length === 1 ? "" : "s"} will be moved to select
              status , kindly confirm
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
            onClick={handleHideSelectUser}
          >
            Cancel
          </button>
          <button
            className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
            onClick={() => handleSelectRejectStatus("select")}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showMailTest} centered onHide={handleHideMailTest} size="lg">
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Test Email</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              {from && (
                <div className="d-flex">
                  <Form.Label style={{ width: "50px" }}>From</Form.Label>

                  <p>{from}</p>
                </div>
              )}
            </Form.Group>
            <Form.Group>
              <div className="d-flex mb-3">
                <Form.Label style={{ width: "50px" }}>To</Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {toEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmailTest(x)}
                    >
                      {x}
                    </Badge>
                  ))}
                  <Form.Control
                    type="text"
                    value={inputValueTest}
                    onChange={(e) => setInputValueTest(e.target.value)}
                    placeholder="Add email and press enter"
                    onKeyDown={handleKeyDownTest}
                    className="border-0"
                  // style={{
                  //   border: "none",
                  //   display: "inline-block",
                  //   width: "auto",
                  // }}
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>
            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "170px" }}
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                value={emailContent}
                onChange={setEmailContent}
              />
            </div>
          </div>
          <div className="row justify-content-end mt-4">
            <div className="col-2 d-flex justify-content-end">
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
                name="only email send"
                onClick={handleSendEmailTest}
              >
                Send
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={testMsgRoundtwo}
        centered
        onHide={handleHideTestMsgRoundtwo}
        size="lg"
      >
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Test Message</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              {from && (
                <div className="d-flex">
                  <Form.Label style={{ width: "50px" }}>From</Form.Label>
                  <p>{from}</p>
                </div>
              )}
            </Form.Group>
            <Form.Group>
              <div className="d-flex mb-3">
                <Form.Label style={{ width: "50px" }}>To</Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {/* {toEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmailTest(x)}
                    >
                      {x}
                    </Badge>
                  ))} */}
                  <Form.Control
                    type="number"
                    value={phoneMsg}
                    onChange={(e) => setPhoneMsg(e.target.value)}
                    // value={inputValueTest}
                    // onChange={(e) => setInputValueTest(e.target.value)}
                    placeholder="Enter the phone number"
                    // onKeyDown={handleKeyDownTest}
                    className="border-0"
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>
            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "170px" }}
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                value={emailContent}
                onChange={setEmailContent}
              />
            </div>
          </div>
          <div className="row justify-content-end mt-4">
            <div className="col-2 d-flex justify-content-end">
              <button
                className="border-0 text-white text-nowrap px-3 py-2 rounded-1 btnVldt"
                style={{ fontSize: "12px" }}
                name="whatsappapplicationroundtwo"
                onClick={handleSendTestMsg}
              // onClick={handleSendEmailTest}
              >
                Send Message
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={testMsg} centered onHide={handleHideTestMsg} size="lg">
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Test Message</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form.Group>
              {from && (
                <div className="d-flex">
                  <Form.Label style={{ width: "50px" }}>From</Form.Label>
                  <p>{from}</p>
                </div>
              )}
            </Form.Group>
            <Form.Group>
              <div className="d-flex mb-3">
                <Form.Label style={{ width: "50px" }}>To</Form.Label>
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                >
                  {/* {toEmails.map((x, index) => (
                    <Badge
                      pill
                      key={index}
                      bg="secondary"
                      className="m-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeEmailTest(x)}
                    >
                      {x}
                    </Badge>
                  ))} */}
                  <Form.Control
                    type="number"
                    value={phoneMsg}
                    onChange={(e) => setPhoneMsg(e.target.value)}
                    // value={inputValueTest}
                    // onChange={(e) => setInputValueTest(e.target.value)}
                    placeholder="Enter the phone number"
                    // onKeyDown={handleKeyDownTest}
                    className="border-0"
                  ></Form.Control>
                </div>
              </div>
            </Form.Group>
            <div style={{ height: "200px" }}>
              <ReactQuill
                style={{ height: "170px" }}
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                value={emailContent}
                onChange={setEmailContent}
              />
            </div>
          </div>
          <div className="row justify-content-end mt-4">
            <div className="col-2 d-flex justify-content-end">
              <button
                className="border-0 text-white text-nowrap px-3 py-2 rounded-1 btnVldt"
                style={{ fontSize: "12px" }}
                name="whatsappapplicationone"
                onClick={handleSendTestMsg}
              // onClick={handleSendEmailTest}
              >
                Send Message
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Modal
        show={showPerCard}
        onHide={handleClosePerCard}
        dialogClassName="custom-modal"
        size="sm"
        centered
      >
        <Modal.Header closeButton className="custom-close-btn"></Modal.Header>

        <Modal.Body>
          <div className="col p-3 border rounded-3">
            <div className="">
              <div className="d-flex px-3">
                <h5
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    lineHeight: "30px",
                  }}
                  className="me-2"
                >
                  78%
                </h5>
                <p>----------------------</p>
              </div>
              <div className="d-flex align-items-center">
                <img className="me-2" src={mediatorLetter} />
                <h2
                  className="mb-0"
                  style={{ fontSize: "20px", fontWeight: "700" }}
                >
                  Mediator
                </h2>
              </div>
              <p className="px-3 py-3" style={{ fontSize: "12px" }}>
                A well-spoken, detail-oriented, productive, and friendly
                individual who is easy to collaborate with. Has the patience to
                find the best possible solution which is both creative and
                efficient.
              </p>
              <img src={shareicon} onClick={handleShowMainPercard} />
            </div>
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
        // show={showMainPerCard}
        // onHide={handleCloseMainpercard}
        size="lg"
        centered
      ></Modal>
      <UserActivity showLog={showLog} userId={userId} name={userName}
        handleClose={handleCloseLog}
        filterData={filterData}
      />

      <AdvanceFilter
        applicatnts={filteredData?.length ? filteredData : allData}
        show={showAdvanceFilter}
        customQuestion={customQuestion}
        setAccessCoeList={(data) => {
          setAccessCoeList(data)
          setFilteredData([])
        }}
        setShowAdvanceFilter={setShowAdvanceFilter}
        setIsFilter={setIsFilter}
        isClearFilters={isClearFilters}
        setIsClearFilters={setIsClearFiltres}
        setFilteredInfo={setFilteredInfo}
        code={code}
        setFilteredData={setFilteredData}
        allData={allData}
      />
      <AddNotes isAddNotes={isAddNotes}
        setIsAddNotes={setIsAddNotes}
        notes={notes}
        userId={userId}
        userName={userName}
        codeId={codeId}
        handleGetNotes={handleGetNotes}
        getList={getList}
        code={code}

      />

      <DetailedPersonality
        isDetailedPersonality={isDetailedPersonality} setIsDetailedPersonality={setIsDetailedPersonality}
        code={code}
        getList={getList}
        setCountMatch={setCountMatch}
      />

      <PersonalityReoprtALert
        isShowCandidateReport={isShowCandidateReport}
        setIsShowCandidateReport={setIsShowCandidateReport}
        userId={userId}
        code={code}
        credits={credits}
        getList={getList}
        userName={userName}
      />

      <MessageBox isOpen={showSummaryMsg} setIsOpen={setSummaryMsg}>
        <div className="mt-2">
          <div >
            <h6 className="text-center interRegular">Your request for candidate summary for {selectsRec?.length} candidates is in progress, once ready it will get emailed to you.
            </h6>
          </div>
          <div className="d-flex justify-content-center gap-1 mt-2">
            <CustomButton
              title="Ok"
              // isLoading={isGenerating}
              handleClick={() => {
                setSelectsRec([])
                getList(code)
                setSummaryMsg(false)

              }}
            />



          </div>

        </div>
      </MessageBox>

    </div >
  );
};

export default AccessCode;
